// Czech translations for FLEETORA
const cs = {
  // Locale identifier for date formatting
  locale: 'cs-CZ',
  
  // Platform
  platform: {
    name: "FLEETORA",
    subtitle: "Platforma pro operační dohled",
    byLine: "od Aeroway",
  },

  organizationScope: {
    allOrganizations: "Všechny organizace",
    selectPlaceholder: "Vyberte organizaci",
    selectTitle: "Vyberte organizaci",
    selectDescription: "Pro zobrazení této stránky nejprve zvolte organizaci, za kterou chcete pracovat.",
    selectAction: "Přejít na výběr organizace",
    viewOrganization: "Vybrat / nahlížet",
    viewingOrganization: "Aktivní organizace",
    loadError: "Nepodařilo se načíst seznam organizací.",
    retryAction: "Zkusit znovu",
    formDirtyConfirm: "Rozpracovaný formulář se zavřením zahodí. Opravdu chcete přepnout organizaci?",
  },
  
  // Common (merged - single definition)
  common: {
    organization: "Organizace",
    status: "Stav",
    date: "Datum",
    actions: "Akce",
    loading: "Načítání...",
    uploading: "Nahrávám...",
    processing: "Zpracovávám...",
    upload: "Nahrát",
    cancel: "Zrušit",
    noData: "Žádná data k dispozici",
    error: "Došlo k chybě",
    success: "Úspěch",
    confirm: "Potvrdit",
    yes: "Ano",
    no: "Ne",
    dropFilesHint: "Přetáhněte soubory nebo klikněte na Nahrát",
    info: "Informace",
    all: "Vše",
    none: "Žádné",
    notes: "Poznámky",
    language: "Jazyk",
    english: "Angličtina",
    czech: "Čeština",
    optional: "volitelné",
    defined: "Definováno",
    unlimited: "Neomezeno",
    upgrade: "Upgradovat",
    current: "Aktuální",
    included: "Zahrnuto",
    locked: "Zamčeno",
  },
  
  // Subscription & Tiers
  subscription: {
    title: "Předplatné",
    currentPlan: "Aktuální plán",
    yourPlan: "Váš plán",
    features: "Funkce",
    limits: "Limity",
    usage: "Využití",
    upgradeTitle: "Upgradujte svůj plán",
    upgradeDescription: "Odemkněte více funkcí a odstraňte limity",
    contactUs: "Kontaktujte nás pro upgrade",
    contactEmail: "sales@fleetora.com",
    tiers: {
      free: "Zdarma",
      professional: "Professional",
      enterprise: "Enterprise"
    },
    tierDescriptions: {
      free: "Základní sledování dronových operací",
      professional: "Kompletní nástroje pro profesionální operátory",
      enterprise: "Kompletní platforma s API přístupem a SSO"
    },
    featureLabels: {
      checkmate: "CheckMate SORA 2.5 Engine",
      sora: "SORA předběžné hodnocení",
      ai_document_generation: "AI generování dokumentů",
      document_review: "AI revize dokumentů",
      ucl_submissions: "Sledování podání ÚCL",
      document_storage: "Úložiště dokumentů",
      scenarios: "Správa scénářů",
      insurance_tracking: "Sledování pojištění",
      authorizations: "Správa autorizací",
      bulletins: "Regulatorní bulletiny",
      reports: "Reporty a analytika",
      api_access: "API přístup",
      sso: "Single Sign-On (SSO)",
      audit_logs: "Auditní logy",
      priority_support: "Prioritní podpora"
    },
    resourceLabels: {
      pilots: "Piloti",
      aircraft: "Letouny",
      batteries: "Baterie",
      missions: "Mise",
      documents: "Dokumenty"
    },
    locked: {
      title: "Prémiová funkce",
      requires: "Tato funkce vyžaduje",
      upgrade: "Upgradovat",
      viewPlans: "Zobrazit plány"
    }
  },

  // Navigation modules
  nav: {
    dashboard: "Přehled",
    flightOps: "Operace",
    crew: "Piloti",
    fleet: "Technika",
    equipment: "Technika",
    safety: "Incidenty",
    compliance: "Soulad s předpisy",
    intelligence: "Analytika",
    reports: "Reporty",
    users: "Uživatelé",
    organizations: "Organizace",
    alertHistory: "Historie upozornění",
    auditSimulation: "Simulace auditu",
    knowledgeBase: "Správa knowledge base",
    insurance: "Pojištění",
    authorizations: "Autorizace",
    submissions: "Podání ÚCL",
    news: "Novinky a předpisy",
    bulletins: "Bulletiny",
    correspondence: "Korespondence",
    fleetMap: "Mapa flotily",
  },
  
  // User roles
  roles: {
    platform_admin: "Admin platformy",
    organization_admin: "Admin organizace",
    compliance_manager: "Compliance manažer",
    pilot: "Pilot",
    operator: "Operátor",
    viewer: "Prohlížející",
  },
  
  // Sub-navigation items
  subNav: {
    // FlightOps
    missions: "Mise",
    missionDetail: "Detail mise",
    missionChecklist: "Checklist mise",
    dailyOps: "Denní přehled",
    missionCalendar: "Kalendář misí",
    missionHistory: "Historie misí",
    
    // Crew
    pilots: "Piloti",
    certifications: "Certifikace",
    
    // Fleet
    aircraft: "Drony",
    batteries: "Baterie",
    equipment: "Vybavení",
    
    // Safety
    incidents: "Incidenty",
    investigation: "Vyšetřování",
    
    // Compliance
    scenarios: "Scénáře",
    documents: "Dokumenty",
    complianceChecks: "Kontroly souladu",
    
    // Reports
    pdfReports: "PDF reporty",
    csvExport: "CSV export",
    missionBrief: "Briefing mise",
  },
  
  // Page Descriptions
  pageDescriptions: {
    missions: "Letové operace",
    pilots: "Správa certifikací a oprávnění pilotů",
    aircraft: "Správa flotily dronů a údržby",
    batteries: "Sledování životního cyklu baterií a bezpečnosti",
    scenarios: "Správa schválených provozních scénářů (ConOps, SORA)",
    documents: "Sledování regulačních dokumentů a záznamů o souladu",
    incidents: "Hlášení a sledování bezpečnostních incidentů",
    missionDetail: "Přehled mise",
  },
  
  // Common actions
  actions: {
    save: "Uložit",
    cancel: "Zrušit",
    delete: "Smazat",
    edit: "Upravit",
    create: "Vytvořit",
    add: "Přidat",
    update: "Aktualizovat",
    search: "Hledat",
    filter: "Filtrovat",
    export: "Exportovat",
    import: "Importovat",
    download: "Stáhnout",
    upload: "Nahrát",
    generate: "Vygenerovat",
    view: "Zobrazit",
    back: "Zpět",
    submit: "Odeslat",
    confirm: "Potvrdit",
    close: "Zavřít",
    resolve: "Vyřešit",
    report: "Nahlásit",
    markAsResolved: "Označit jako vyřešené",
    refresh: "Obnovit",
  },
  
  // Auth
  auth: {
    login: "Přihlášení",
    logout: "Odhlásit",
    email: "E-mail",
    password: "Heslo",
    showPassword: "Zobrazit heslo",
    hidePassword: "Skrýt heslo",
    signIn: "Přihlásit se",
    welcomeBack: "Vítejte zpět",
    enterCredentials: "Zadejte přihlašovací údaje pro přístup do platformy",
    // Login page hero section
    heroDescription: "Zajistěte regulační soulad, udržujte připravenost na audit a monitorujte své dronové operace s jistotou.",
    featureEASA: "Soulad s EASA Open & Specific Category",
    featureMonitoring: "Monitoring souladu v reálném čase",
    featureCertification: "Automatické sledování certifikací",
    // Loading screen
    loadingText: "Načítání FLEETORA",
  },

  // Application version in the user menu
  appVersion: {
    version: "Verze {version}",
    built: "build {date}",
  },
  
  // Dashboard - Denní přehled (Operační dispečink)
  dashboard: {
    live: "ŽIVĚ",
  },
  
  // Analytics Dashboard
  analytics: {
    title: "Analytika",
    subtitle: "Provozní přehledy a U-Space připravenost",
    operationalOverview: "Provozní přehled",
    missionAnalysis: "Analýza misí",
    safetyAndUSpace: "Bezpečnost, soulad a U-Space",
    documentExpiry: "Monitoring dokumentů",
    totalMissions: "Mise v období",
    avgTimeToReady: "Průměrný čas do Ready",
    fromCreation: "od vytvoření",
    activePilots: "Aktivní piloti",
    thisPeriod: "v období",
    incidentsThisMonth: "Incidenty",
    missionStatusBreakdown: "Rozdělení stavů misí",
    sailDistribution: "Distribuce SAIL úrovní",
    safetyCompliance: "Bezpečnost a soulad",
    complianceRate: "Míra souladu",
    readyBeforeMission: "Mise připravené včas",
    soraConfidence: "Spolehlivost SORA",
    topMissingReq: "Nejčastější chybějící požadavky",
    uSpaceReadiness: "U-Space připravenost",
    fleetStatus: "Stav flotily",
    drones: "dronů",
    topFlightHours: "Nejvíce nalétaných hodin",
    approachingService: "Blíží se servisní interval",
    allDronesOk: "Všechny drony v servisních limitech",
    documentAlerts: "Upozornění na expiraci dokumentů",
    expiring30: "Vyprší do 30 dnů",
    expiring90: "Vyprší za 31-90 dnů",
    noExpiringDocs: "Žádné expirující dokumenty",
    week: "Tento týden",
    month: "Tento měsíc",
    quarter: "Toto čtvrtletí",
    year: "Tento rok",
    allOrgs: "Všechny organizace",
    status: {
      draft: "Koncept",
      in_progress: "Probíhá",
      ready: "Připraveno",
      completed: "Dokončeno",
      cancelled: "Zrušeno"
    }
  },
  
  // FlightOps / Missions
  flightOps: {
    title: "Letové operace",
    missions: "Mise",
    logMission: "Zaznamenat misi",
    missionId: "ID mise",
    missionDate: "Datum mise",
    location: "Název lokality",
    locationHelper: "Stručný popis místa (např. 'Inspekce VVN V401 Bezděz')",
    missionLocationHelper: "Klikněte na mapě nebo vyhledejte adresu",
    pilot: "Pilot",
    aircraft: "Dron",
    scenario: "Scénář",
    readiness: "Připravenost",
    compliance: "Soulad",
    missionDetail: "Detail mise",
    missionOverview: "Přehled mise",
    operationsPlanning: "Plánování operací",
    address: "Adresa",
    generateBrief: "Vygenerovat briefing",
    briefLanguage: "Jazyk briefingu",
    editMission: "Upravit misi",
    logNewMission: "Zaznamenat novou misi",
    missionNotes: "Poznámky k misi...",
    confirmMitigation: "Potvrzuji, že všechna opatření pro snížení rizik byla při této misi dodržena",
    confirmMitigationRequired: "Potvrďte prosím, že byla dodržena všechna opatření pro snížení rizik",
    selectOrganization: "Vyberte organizaci",
    selectPilot: "Vyberte pilota",
    selectAircraft: "Vyberte dron",
    selectScenario: "Vyberte scénář (doporučeno)",
    operationalScenario: "Provozní scénář",
    notes: "Poznámky",
    missionInformation: "Informace o misi",
    noScenarioAssigned: "Není přiřazen žádný scénář",
    missionNotFound: "Mise nenalezena",
    backToMissions: "Zpět na mise",
    noChecklistAvailable: "Checklist není k dispozici",
    complete: "hotovo",
    attachments: "Přílohy",
    noAttachments: "Zatím žádné přílohy",
    uploadHint: "Nahrajte důkazy o misi, reporty nebo obrázky",
    imagePreview: "Náhled obrázku",
    imageLoadError: "Nepodařilo se načíst obrázek",
    // Location / Map
    coordinates: "Souřadnice",
    clickToSet: "Klikněte na mapu pro nastavení polohy",
    latitude: "Zeměpisná šířka",
    longitude: "Zeměpisná délka",
    missionLocation: "Lokace mise",
    noCoordinates: "Souřadnice nejsou nastaveny",
    editToAddLocation: "Upravte misi pro přidání lokace",
    locationRequired: "Nastavte lokaci pro ověření vzdušného prostoru",
    setLocation: "Nastavit lokaci",
    searchLocation: "Hledat adresu nebo místo...",
    openInDroneMap: "Otevřít v DroneMap",
    droneMapDisclaimer: "Pro oficiální omezení vzdušného prostoru a předpisy prosím ověřte tuto lokaci v DroneMap.",
    copyAddress: "Kopírovat adresu",
    copyCoordinates: "Kopírovat souřadnice",
    addressCopied: "Adresa zkopírována do schránky",
    coordinatesCopied: "Souřadnice zkopírovány do schránky",
    clipboardCopyError: "Nepodařilo se zkopírovat do schránky",
    verifyInDroneMap: "Ověřit v DroneMap",
    droneMapHelper: "Zkopírujte lokaci a vložte ji do vyhledávání DroneMap.",
    // NEW: Max altitude
    maxAltitude: "Max. výška letu (m AGL)",
    maxAltitudeHelper: "Nejvyšší výška nad terénem kdekoli v oblasti letu",
    maxAltitudeShort: "Max. výška",
    // Recommended altitude from the ŘLP height grid under the flight area (lib/heightLimit.js)
    altitudeGrid: {
      autoSingle: "Nastaveno podle výškové mřížky ŘLP pod oblastí letu: {value} m.",
      auto: "Nastaveno podle výškové mřížky ŘLP pod oblastí letu: {value} m (nejnižší ze zasažených buněk, počet {cells}).",
      matches: "Odpovídá výškové mřížce ŘLP pod oblastí letu ({value} m).",
      manual: "Podle výškové mřížky ŘLP pod oblastí letu: {value} m — zadáno ručně.",
      stored: "Podle výškové mřížky ŘLP pod oblastí letu: {value} m (uložená hodnota ponechána).",
      differs: "Podle výškové mřížky ŘLP pod oblastí letu: {value} m.",
      above: "Zadaná výška je nad mřížkou ŘLP ({value} m).",
      apply: "Použít doporučených {value} m",
      partial: "Část oblasti leží mimo mřížku; tam hodnota neplatí.",
      zero: "Oblast letu zasahuje buňku výškové mřížky ŘLP s výškou 0 m — výšku z mřížky nelze doporučit, zadejte ji ručně.",
      outside: "Oblast letu nezasahuje výškovou mřížku ŘLP — výšku nastavte podle svého provozu.",
      error: "Výšku podle mřížky ŘLP se nepodařilo zjistit.",
      loading: "Zjišťuji výšku podle mřížky ŘLP…",
      disclaimer: "Jde o doporučení podle dat ŘLP, ne o povolení letu.",
      overwritten: "Výška letu upravena podle výškové mřížky ŘLP: {value} m.",
    },
    saveMissionError: "Nepodařilo se uložit misi. Zkontrolujte všechna pole a zkuste znovu.",
  },
  
  // Mission states
  missionStatus: {
    draft: "Návrh",
    inProgress: "Probíhá",
    ready: "Připraveno",
    notReady: "Není připraveno",
    compliant: "V souladu",
    nonCompliant: "Nesoulad",
  },
  
  // Compliance Detail
  complianceDetail: {
    title: "Stav shody",
    checklistComplete: "Checklist dokončen",
    mitigationConfirmed: "Mitigace potvrzena",
    documentsValid: "Dokumenty platné",
    pilotAuthorized: "Oprávnění pilota",
    sailAcceptable: "Úroveň SAIL přijatelná",
    soraConfidence: "Spolehlivost SORA",
    soraRequirements: "Požadavky SORA",
    advisory: "informativní",
    blocking: "blokující",
    items: "položek",
    missing: "chybí",
    expired: "vypršelo",
    highSailWarning: "SAIL V/VI vyžaduje zvláštní povolení",
    pilotCertExpired: "Certifikát pilota vypršel",
    aircraftInsuranceExpired: "Pojištění dronu vypršelo",
    noBlockingIssues: "Žádné blokující problémy",
  },
  
  // Checklist
  checklist: {
    title: "Předletový checklist",
    saveChecklist: "Uložit checklist",
    equipment: "Vybavení",
    pilotSection: "Pilot",
    documentation: "Dokumentace",
    aircraftReady: "Dron technicky připraven",
    batteryChecked: "Stav baterie zkontrolován",
    equipmentAssigned: "Vybavení přiděleno",
    pilotAssigned: "Pilot přidělen",
    licenseVerified: "Licence ověřena",
    internalAuthConfirmed: "Interní oprávnění potvrzeno",
    scenarioAssigned: "Scénář přidělen",
    docsAvailable: "Požadovaná dokumentace dostupná",
    conopsReviewed: "ConOps / postupy zkontrolovány",
    // Section names (from backend checklist)
    preFlightPlanning: "Plánování před letem",
    equipmentCheck: "Kontrola vybavení",
    pilotReadiness: "Připravenost pilota",
    operationalArea: "Operační oblast",
    // Checklist items
    missionDateSet: "Datum mise nastaveno",
    locationDefined: "Lokace definována",
    aircraftAssigned: "Dron přidělen",
    pilotAssignedItem: "Pilot přidělen",
    scenarioSelected: "Scénář vybrán",
    aircraftOperational: "Dron provozuschopný",
    batteryCharged: "Baterie nabitá",
    equipmentInspected: "Vybavení zkontrolováno",
    pilotCertValid: "Certifikace pilota platná",
    pilotBriefed: "Pilot poučen",
    weatherChecked: "Počasí zkontrolováno",
    airspaceChecked: "Vzdušný prostor zkontrolován",
    notamReviewed: "NOTAM zkontrolován",
    areaSecured: "Oblast zajištěna",
  },
  
  // Checklist states
  checklistStatus: {
    notStarted: "Nezahájeno",
    inProgress: "Probíhá",
    completed: "Splněno",
  },
  
  // Crew / Pilots
  crew: {
    title: "Správa posádky",
    pilots: "Piloti",
    addPilot: "Přidat pilota",
    editPilot: "Upravit pilota",
    pilotName: "Jméno pilota",
    pilotEmail: "E-mail",
    authorizations: "Oprávnění a certifikace",
    authA1A3: "Certifikát A1/A3 (Otevřená kategorie)",
    authA2: "Certifikát A2 (Otevřená kategorie - blízko lidí)",
    authSpecific: "STS oprávnění",
    authInternal: "Interní firemní oprávnění / školení",
    issueDate: "Datum vydání",
    expirationDate: "Datum expirace",
    trainingDate: "Datum školení/vydání",
    expirationOptional: "Datum expirace (volitelné)",
    valid: "Platný",
    expiring: "Expirující",
    invalid: "Neplatný",
    expired: "Expirovaný",
    pilotsExpiredAlert: "pilot(ů) s expirovanými certifikacemi",
    pilotsExpiringAlert: "pilot(ů) s expirujícími certifikacemi",
    searchPilots: "Hledat piloty...",
    noPilotsFound: "Žádní piloti nenalezeni",
    documents: "Dokumenty",
    noDocuments: "Žádné dokumenty nahrané",
    uploadHint: "Nahrajte skeny licencí, certifikátů školení nebo jiné dokumenty",
    license: "Licence",
    trainingCertificate: "Certifikát školení",
    medical: "Zdravotní certifikát",
  },
  
  // Fleet
  fleet: {
    title: "Správa flotily",
    aircraft: "Drony",
    aircraftFleet: "Flotila dronů",
    batteries: "Baterie",
    addAircraft: "Přidat dron",
    editAircraft: "Upravit dron",
    addBattery: "Přidat baterii",
    editBattery: "Upravit baterii",
    model: "Model",
    serialNumber: "Sériové číslo",
    firmwareVersion: "Verze firmware",
    registrationNumber: "Registrační číslo",
    lastMaintenance: "Poslední údržba",
    serviceInterval: "Servisní interval (hodiny)",
    flightHours: "Nalétané hodiny",
    serviceCycle: "Servisní cyklus",
    cycleCount: "Počet cyklů",
    cycleLimit: "Limit cyklů",
    status: "Stav",
    operational: "Provozuschopný",
    maintenanceSoon: "Brzy údržba",
    maintenanceRequired: "Nutná údržba",
    aircraftMaintenanceAlert: "dronů potřebuje okamžitou údržbu",
    aircraftMaintenanceSoonAlert: "dronů potřebuje brzy údržbu",
    searchAircraft: "Hledat drony...",
    noAircraftFound: "Žádné drony nenalezeny",
    unregistered: "Neregistrovaný",
    assignedAircraft: "Přiřazený dron",
    cycleUsage: "Využití cyklů",
    good: "V pořádku",
    warning: "Varování",
    replace: "Vyměnit",
    batteryReplaceAlert: "baterií potřebuje výměnu",
    batteryApproachingAlert: "baterií se blíží limitu",
    searchBatteries: "Hledat baterie...",
    noBatteriesFound: "Žádné baterie nenalezeny",
    selectAircraftOptional: "Vyberte dron (volitelné)",
    // Aircraft Documents
    documents: "Dokumenty",
    registration: "Registrace",
    maintenance: "Údržba",
    inspection: "Inspekce",
    technicalCertificate: "Technický certifikát",
    noDocuments: "Žádné dokumenty nenahrány",
    uploadHint: "Nahrajte registraci, záznamy o údržbě nebo inspekční dokumenty",
    // SORA Equipment
    soraEquipment: "Vybavení SORA",
    soraEquipmentHint: "Vyberte nainstalované bezpečnostní vybavení pro předběžné hodnocení SORA",
    parachute: "Padák",
    fts: "Systém ukončení letu (FTS)",
    geoAwareness: "Geo-awareness",
    remoteId: "Remote ID",
    // Remote ID Compliance
    remoteIdSection: "Remote ID Compliance",
    remoteIdSerial: "Sériové číslo RID",
    remoteIdType: "Typ Remote ID",
    remoteIdCompliant: "RID ověřen",
    remoteIdTypes: {
      built_in: "Vestavěný",
      add_on: "Přídavný modul",
      broadcast_only: "Pouze vysílání",
      none: "Žádný"
    },
    remoteIdStatus: {
      compliant: "Vyhovující",
      nonCompliant: "Nevyhovující",
      unknown: "Neznámé"
    },
    // Block I-2: Remote ID icon tooltips
    ridIcon: {
      header: "Remote ID",
      builtIn: "Vestavěné",
      external: "Externí modul",
      compliant: "Vyhovující",
      exempted: "S výjimkou",
      nonCompliant: "Nevyhovující",
      unknown: "Neznámé"
    },
    remoteIdWarning: "Dron nemá ověřený Remote ID — zkontrolujte před letem",
    // NEW: MTOM and UA Class
    mtomKg: "MTOM (kg)",
    maxSpeedMs: "Max. rychlost (m/s)",
    maxSpeedHelper: "Výrobcem deklarovaná maximální rychlost (m/s) — povinná, vstup výpočtu rizika podle SORA 2.5.",
    maxSpeedHelperRecommended: "Výrobcem deklarovaná maximální rychlost (m/s) — doporučujeme doplnit, vstup výpočtu rizika podle SORA 2.5.",
    maxSpeedMissing: "Chybí max. rychlost",
    maxSpeedMissingHint: "U tohoto letadla chybí výrobcem deklarovaná maximální rychlost — SORA pro něj počítá jen zjednodušený odhad z MTOM a výšky. Doplňte ji v úpravě letadla.",
    maxSpeedMissingDialogHint: "U tohoto letadla chybí výrobcem deklarovaná maximální rychlost — SORA pro něj počítá jen zjednodušený odhad z MTOM a výšky. Letadlo lze uložit i bez ní.",
    mtomHelper: "Maximální vzletová hmotnost včetně veškerého nákladu — povinná, určuje třídu UA a vstupuje do výpočtu SORA.",
    mtomHelperRecommended: "Maximální vzletová hmotnost včetně veškerého nákladu — doporučujeme doplnit, určuje třídu UA a vstupuje do výpočtu SORA.",
    mtomMissing: "Chybí MTOM",
    mtomMissingHint: "U tohoto letadla chybí maximální vzletová hmotnost (MTOM) — třídu UA nelze určit a SORA pro něj počítá s konzervativním odhadem 25 kg. Doplňte ji v úpravě letadla.",
    mtomMissingDialogHint: "U tohoto letadla chybí maximální vzletová hmotnost (MTOM) — třídu UA nelze určit a SORA pro něj počítá s konzervativním odhadem 25 kg. Letadlo lze uložit i bez ní.",
    soraInputsMissing: "Chybí údaje pro SORA",
    soraInputsMissingHint: "U tohoto letadla chybí maximální vzletová hmotnost (MTOM) i výrobcem deklarovaná maximální rychlost — třídu UA nelze určit a SORA pro něj počítá jen se zjednodušenými odhady. Doplňte je v úpravě letadla.",
    // Desetinná tečka: číselné pole ji přijme v každém prohlížeči, čárku ne všude
    mtomPlaceholder: "např. 2.5",
    uaCategoryEnterMtom: "Zadejte MTOM",
    // Skupiny polí v dialogu letadla
    formGroupIdentification: "Identifikace",
    formGroupTechnical: "Technické parametry",
    formGroupClass: "Kategorie a označení",
    formGroupMaintenance: "Údržba a provoz",
    legacyDrone: "Dron bez označení C0-C6",
    legacyDroneHelper: "Starší nebo soukromá stavba bez označení třídy EU",
    uaCategory: "Kategorie UA",
    noClassMarking: "Bez označení",
    modelRequired: "Model letadla je povinný.",
    serialNumberRequired: "Sériové číslo je povinné.",
    maxSpeedRequired: "Výrobcem deklarovaná maximální rychlost je povinná.",
    maxSpeedPositive: "Maximální rychlost musí být kladné číslo v m/s.",
    mtomRequired: "Maximální vzletová hmotnost (MTOM) je povinná.",
    mtomPositive: "MTOM musí být kladné číslo v kg.",
    // Charakteristický rozměr SORA (vstup pro tabulku 2 iGRC)
    characteristicDimensionSection: "Charakteristický rozměr (SORA)",
    characteristicDimensionSectionSubtitle: "Použije se pro kvantitativní tabulku pozemního rizika SORA 2.5",
    maxCharacteristicDimensionM: "Maximální charakteristický rozměr (m)",
    maxCharacteristicDimensionHelper: "Rozpětí křídel (pevná křídla), průměr hlavního rotoru (vrtulník), nebo maximální vzdálenost mezi konci rotorových listů (multirotor) — vstup pro podrobnější výpočet rizika podle SORA 2.5.",
    maxCharacteristicDimensionHelpTitle: "Jak měřit charakteristický rozměr",
    maxCharacteristicDimensionRequired: "Povinné pro nový dron — použije se v tabulce pozemního rizika SORA 2.5.",
    maxCharacteristicDimensionPositive: "Maximální charakteristický rozměr musí být kladné číslo v metrech.",
    maxCharacteristicDimensionLockedHelper: "U tohoto dronu už je zaznamenaný — smazání tady není podporované, aby se neztratila hodnota důležitá pro SORA.",
    diagramFixedWing: "Pevná křídla — rozpětí křídel",
    diagramHelicopter: "Vrtulník — průměr hlavního rotoru",
    diagramMultirotor: "Multirotor — max. vzdálenost konců listů",
    detectedFromCatalog: "Zjištěno z katalogu dronů: {type}",
    selectAircraftType: "Vyberte konstrukci dronu pro zobrazení odpovídajícího diagramu:",
    vtolAmbiguousHelper: "Tento dron VTOL může mít geometrii pevných křídel i multirotoru — vyberte tu, která odpovídá jeho skutečné konstrukci:",
    droneTypes: {
      fixed_wing: "Pevná křídla",
      helicopter: "Vrtulník",
      multirotor: "Multirotor",
      vtol: "VTOL",
      other: "Jiné"
    },
    // Filter chips (Block I-1)
    filterChips: {
      all: "Vše",
      operational: "Provozuschopné",
      maintenanceSoon: "Brzy údržba",
      maintenanceRequired: "Nutná údržba"
    },
    // Status tooltip (Block M-3)
    statusTooltip: {
      required: "Nutná údržba",
      soon: "Brzy údržba",
      operational: "Provozuschopné",
      hoursReason: "Nálet: {current}/{limit} h",
      calendarReason: "Kalendář: {current}/{limit} dní",
      missingDate: "Chybí datum poslední údržby",
      bothAxes: "Překročeny oba limity"
    },
    // Service bar units (Block M-3 update)
    serviceBarUnits: {
      hours: "h",
      days: "d"
    },
  },
  
  // Safety / Incidents
  safety: {
    title: "Správa bezpečnosti",
    incidents: "Incidenty",
    reportIncident: "Nahlásit incident",
    editIncident: "Upravit incident",
    incidentDate: "Datum incidentu",
    classification: "Klasifikace",
    severity: "Závažnost",
    description: "Popis",
    correctiveActions: "Nápravná opatření",
    correctiveActionsIfAny: "Nápravná opatření (pokud existují)",
    reportingRequired: "Nutné hlášení úřadům",
    missionReference: "Reference mise",
    equipmentInvolved: "Zúčastněné vybavení",
    equipmentType: "Typ vybavení",
    selectEquipmentType: "Vyberte typ vybavení",
    notEquipmentRelated: "Nesouvisí s vybavením",
    aircraftInvolved: "Zúčastněný dron",
    batteryInvolved: "Zúčastněná baterie",
    selectEquipment: "Vyberte vybavení",
    noneSelected: "Nevybráno",
    selectMission: "Vyberte misi (volitelné)",
    noLinkedMission: "Žádná propojená mise",
    selectMissionById: "Vyberte misi podle ID",
    attachments: "Přílohy",
    uploadFiles: "Nahrát soubory",
    filesDescription: "Obrázky, PDF, dokumenty",
    resolve: "Vyřešit",
    resolveIncident: "Vyřešit incident",
    open: "Otevřený",
    resolved: "Vyřešený",
    minor: "Menší",
    serious: "Vážný",
    low: "Nízká",
    medium: "Střední",
    high: "Vysoká",
    critical: "Kritická",
    openIncidentsAlert: "otevřených incidentů",
    seriousIncidentsAlert: "vážných incidentů",
    searchIncidents: "Hledat incidenty...",
    noIncidentsFound: "Žádné incidenty nenalezeny",
    descriptionPlaceholder: "Popište, co se stalo, okolnosti, přijatá opatření, možné příčiny...",
    correctiveActionsPlaceholder: "Popište přijatá nebo plánovaná nápravná opatření...",
    resolvePlaceholder: "Popište nápravná opatření přijatá k vyřešení tohoto incidentu...",
    other: "Jiné vybavení",
    noAttachments: "Žádné přílohy",
    // Incident types (Wave 3 Block 3C)
    incidentType: "Typ incidentu",
    selectIncidentType: "Vyberte typ incidentu",
    reportableToUcl: "Hlášení ÚCL povinné",
    reportableToUclHint: "Tento incident musí být nahlášen Úřadu pro civilní letectví",
    incidentTypes: {
      equipment_failure: "Porucha vybavení",
      collision_risk: "Riziko kolize",
      loss_of_control: "Ztráta kontroly",
      airspace_violation: "Narušení vzdušného prostoru",
      pilot_error: "Chyba pilota",
      environmental: "Environmentální",
      flyaway: "Úlet (flyaway)",
      injury: "Zranění osob",
      property_damage: "Škoda na majetku",
      other: "Jiné"
    },
    // Photos (Wave 3 Block 3C)
    photos: "Fotodokumentace",
    uploadPhoto: "Nahrát fotku",
    noPhotos: "Žádné fotografie",
    photoMetadata: "Metadata fotografie",
    exifLocation: "GPS souřadnice",
    exifTimestamp: "Čas pořízení",
    exifCamera: "Fotoaparát",
    photoSize: "Velikost",
    maxPhotoSize: "Max. 10 MB",
    imagesOnly: "Povoleny jsou pouze obrázky",
    uploadFailed: "Nahrání selhalo",
    attachmentUploadFailed: "Incident je uložený, ale přílohu „{name}“ se nepodařilo nahrát.",
    photoDeleted: "Fotografie smazána",
    photoDeleteError: "Smazání selhalo",
    // Comments (Wave 3 Block 3C)
    comments: "Komentáře",
    addComment: "Přidat komentář",
    addCommentError: "Nepodařilo se přidat komentář",
    noComments: "Žádné komentáře",
    commentPlaceholder: "Napište komentář...",
    deleteComment: "Smazat komentář",
    commentDeleted: "Komentář smazán",
    commentDeleteError: "Smazání selhalo",
  },
  
  // Compliance Widget (Wave 3 Block 3C)
  complianceWidget: {
    title: "Stav compliance",
    subtitle: "Přehled stavu flotily a posádky",
    pilotsSection: "Piloti",
    aircraftSection: "Drony",
    batteriesSection: "Baterie",
    incidentsSection: "Incidenty",
    valid: "Platné",
    operational: "Provozuschopné",
    good: "V pořádku",
    expiring: "Expirující",
    maintenanceDue: "Potřebuje údržbu",
    warning: "Varování",
    expired: "Expirované",
    grounded: "Odstavené",
    replace: "K výměně",
    openIncidents: "Otevřené",
    seriousOpen: "Vážné otevřené",
    reportableOpen: "K nahlášení ÚCL",
    overallHealthy: "Vše v pořádku",
    overallWarning: "Vyžaduje pozornost",
    overallCritical: "Kritické problémy",
    criticalIssues: "Kritické problémy",
    warnings: "Varování",
    viewDetails: "Zobrazit detaily",
  },
  complianceModule: {
    title: "Správa souladu",
    scenarios: "Provozní scénáře",
    documents: "Dokumenty",
    documentation: "Dokumentace",
    addScenario: "Přidat scénář",
    editScenario: "Upravit scénář",
    addDocument: "Přidat dokument",
    editDocument: "Upravit dokument",
    scenarioName: "Název scénáře",
    scenarioNamePlaceholder: "např. Inspekce potrubí - VLOS",
    operationType: "Typ operace",
    riskMitigations: "Klíčová opatření proti rizikům",
    riskMitigationsPlaceholder: "Popište opatření pro snížení rizik...",
    requiredAuth: "Požadované oprávnění",
    documentType: "Typ dokumentu",
    documentName: "Název dokumentu",
    documentNamePlaceholder: "např. Provozní příručka v3.2",
    documentVersion: "Verze",
    approvalDate: "Datum schválení",
    lastReview: "Poslední revize",
    active: "Aktivní",
    inactive: "Neaktivní",
    searchScenarios: "Hledat scénáře...",
    noScenariosFound: "Žádné scénáře nenalezeny",
    searchDocuments: "Hledat dokumenty...",
    noDocumentsFound: "Žádné dokumenty nenalezeny",
    documentsExpiredAlert: "dokumentů expirovalo",
    documentsExpiringAlert: "dokumentů brzy expiruje",
    selectType: "Vyberte typ",
  },
  
  // Required Documents
  requiredDocs: {
    title: "Požadované dokumenty",
    operationsManual: "Provozní příručka",
    conops: "ConOps",
    sora: "SORA",
    internalProcedures: "Interní postupy",
    available: "Dostupný",
    missing: "Chybí",
    expired: "Expirovaný",
    valid: "Platný",
    expiring: "Expirující",
    unknown: "Neznámý",
  },
  
  // Validation messages
  validation: {
    required: "Toto pole je povinné",
    invalidEmail: "Neplatná e-mailová adresa",
    selectPilot: "Prosím vyberte pilota",
    selectAircraft: "Prosím vyberte dron",
    selectDate: "Prosím vyberte datum",
    enterLocation: "Prosím zadejte lokaci",
    maxAltitudeRange: "Zadejte max. výšku letu od 1 do 500 m AGL",
    enterName: "Prosím zadejte jméno",
    enterPilotName: "Prosím zadejte jméno pilota",
    enterDescription: "Prosím zadejte popis",
    selectIncidentDate: "Prosím vyberte datum incidentu",
    provideIncidentDescription: "Prosím zadejte popis incidentu",
    provideCorrectiveActions: "Prosím zadejte nápravná opatření",
    enterScenarioName: "Prosím zadejte název scénáře",
    selectOperationType: "Prosím vyberte typ operace",
  },
  
  // Success messages
  messages: {
    saved: "Úspěšně uloženo",
    deleted: "Úspěšně smazáno",
    updated: "Úspěšně aktualizováno",
    created: "Úspěšně vytvořeno",
    uploaded: "Soubor úspěšně nahrán",
    checklistSaved: "Checklist úspěšně uložen",
    incidentResolved: "Incident vyřešen",
    missionLogged: "Mise úspěšně zaznamenána",
    missionUpdated: "Mise úspěšně aktualizována",
    missionDeleted: "Mise smazána",
    pilotCreated: "Pilot úspěšně vytvořen",
    pilotUpdated: "Pilot úspěšně aktualizován",
    pilotDeleted: "Pilot smazán",
    aircraftAdded: "Dron úspěšně přidán",
    aircraftUpdated: "Dron úspěšně aktualizován",
    aircraftDeleted: "Dron smazán",
    noChanges: "Žádné změny k uložení",
    batteryAdded: "Baterie úspěšně přidána",
    batteryUpdated: "Baterie úspěšně aktualizována",
    batteryDeleted: "Baterie smazána",
    scenarioCreated: "Scénář úspěšně vytvořen",
    scenarioUpdated: "Scénář úspěšně aktualizován",
    scenarioDeleted: "Scénář smazán",
    documentAdded: "Dokument úspěšně přidán",
    documentUpdated: "Dokument úspěšně aktualizován",
    documentDeleted: "Dokument smazán",
    incidentReported: "Incident úspěšně nahlášen",
    incidentUpdated: "Incident úspěšně aktualizován",
    incidentDeleted: "Incident smazán",
    fetchError: "Nepodařilo se načíst data",
    saveError: "Nepodařilo se uložit",
    deleteError: "Nepodařilo se smazat",
  },

  // Dialog Titles
  dialogs: {
    addMission: "Zaznamenat novou misi",
    editMission: "Upravit misi",
    addPilot: "Přidat pilota",
    editPilot: "Upravit pilota",
    addAircraft: "Přidat dron",
    editAircraft: "Upravit dron",
    addBattery: "Přidat baterii",
    editBattery: "Upravit baterii",
    addScenario: "Přidat scénář",
    editScenario: "Upravit scénář",
    addDocument: "Přidat dokument",
    editDocument: "Upravit dokument",
    reportIncident: "Nahlásit incident",
    editIncident: "Upravit incident",
    resolveIncident: "Vyřešit incident",
    confirmDelete: "Potvrdit smazání",
  },

  // Placeholders
  placeholders: {
    searchMissions: "Hledat...",
    searchPilots: "Hledat piloty...",
    searchAircraft: "Hledat drony...",
    searchBatteries: "Hledat baterie...",
    searchScenarios: "Hledat scénáře...",
    searchDocuments: "Hledat dokumenty...",
    searchIncidents: "Hledat incidenty...",
    selectOrganization: "Vyberte organizaci",
    locationExample: "např. Větrná farma Alpha",
    registrationExample: "EU-REG-XXXX-XXXX",
  },

  // Alerts
  alerts: {
    history: "Historie upozornění",
    historyDescription: "Zobrazit a sledovat všechna upozornění na shodu odeslaná systémem",
    totalAlerts: "Celkem upozornění",
    sent: "Odesláno",
    failed: "Selhalo",
    dryRun: "Testovací režim",
    skipped: "Přeskočeno",
    scheduler: "Plánovač",
    runCheck: "Spustit kontrolu shody",
    alertType: "Typ upozornění",
    severity: "Závažnost",
    status: "Stav",
    entity: "Entita",
    recipient: "Příjemce",
    timestamp: "Čas",
    startDate: "Od data",
    endDate: "Do data",
    noAlerts: "Nenalezena žádná upozornění",
    searchPlaceholder: "Hledat upozornění...",
    alertLog: "Protokol upozornění",
    loadError: "Nepodařilo se načíst historii upozornění",
    runCheckError: "Nepodařilo se spustit kontrolu shody",
    checkComplete: "Kontrola shody dokončena. Zpracováno upozornění: {count}.",
  },

  // Audit
  audit: {
    title: "Simulace auditu shody",
    description: "Simulujte regulační audity shody a identifikujte provozní slabiny",
    runAudit: "Spustit audit",
    results: "Výsledky auditu",
    history: "Historie auditů",
    ready: "PŘIPRAVEN K AUDITU",
    attentionRequired: "VYŽADUJE POZORNOST",
    complianceScore: "Skóre shody",
    passed: "Prošlo",
    warnings: "Varování",
    critical: "Kritické",
    auditId: "ID auditu",
    downloadPackage: "Stáhnout balíček auditu",
    findingsByCategory: "Nálezy podle kategorií",
    findingsDescription: "Podrobný rozpis problémů shody nalezených během auditu",
    pilotCertifications: "Certifikace pilotů",
    aircraftMaintenance: "Údržba letadel",
    batterySafety: "Bezpečnost baterií",
    documentation: "Dokumentace",
    missionCompliance: "Shoda misí",
    incidentStatus: "Stav incidentů",
    scenarioAssignments: "Přiřazení scénářů",
    checked: "zkontrolováno",
    entity: "Entita",
    severity: "Závažnost",
    issue: "Problém",
    suggestedAction: "Doporučená akce",
    noIssues: "V této kategorii nebyly nalezeny žádné problémy",
    noAuditRun: "Žádný audit nebyl spuštěn",
    clickToRun: "Kliknutím na 'Spustit audit' simulujete audit shody pro vybranou organizaci",
    auditHistory: "Historie auditů",
    historyDescription: "Zobrazte předchozí audity a stáhněte balíčky auditu",
    score: "Skóre",
    status: "Stav",
    issues: "Problémy",
    noHistory: "Nenalezena žádná historie auditů",
    // CSV Import audit entries
    filterAll: "Všechny akce",
    filterAuditSimulations: "Simulace auditu",
    filterCsvImports: "CSV importy",
    filterDataExports: "Exporty dat",
    actionAudit: "Simulace auditu",
    actionCsvImport: "CSV import",
    actionDataExport: "Export dat",
    importedRecords: "Importováno",
    skippedRecords: "Přeskočeno",
    failedRecords: "Selhalo",
    sourceFile: "Zdrojový soubor",
    selectOrgError: "Vyberte organizaci",
    auditComplete: "Audit dokončen: {id}",
    runAuditError: "Nepodařilo se spustit audit",
    packageDownloaded: "Balíček auditu stažen",
    downloadError: "Nepodařilo se stáhnout balíček auditu",
    detailLoadError: "Nepodařilo se načíst detail auditu",
  },

  // Reports & Data page
  reports: {
    fetchOrgsError: "Nepodařilo se načíst organizace",
    selectOrgError: "Vyberte organizaci",
    scopeRequired: "Pro tuto akci vyberte konkrétní organizaci. CSV export zůstává dostupný i pro všechny organizace.",
    scopeChangeConfirm: "Máte rozepsaný CSV import. Změna organizace vymaže vložený obsah. Opravdu pokračovat?",
    reportDownloaded: "Report úspěšně stažen",
    reportError: "Nepodařilo se vygenerovat report",
    templateDownloaded: "Šablona stažena",
    templateError: "Nepodařilo se stáhnout šablonu",
    exportSuccess: "Data úspěšně exportována",
    exportError: "Nepodařilo se exportovat data",
    pasteCsvError: "Vložte obsah CSV",
    importSuccess: "Importováno záznamů: {count}",
    importFailedCheckErrors: "Import selhal - zkontrolujte chyby níže",
    importError: "Import selhal",
    alertsSent: "Odesláno upozornění: {count}",
    emailNotConfigured: "E-mailová služba není nakonfigurována. Pro povolení přidejte RESEND_API_KEY.",
    alertsError: "Nepodařilo se odeslat upozornění",
  },

  // CSV Import
  import: {
    title: "Import z CSV",
    subtitle: "Hromadný import dat z CSV souboru",
    scopeChangeConfirm: "Import na serveru stále probíhá. Při změně organizace se zavře tento dialog a sledování průběhu skončí, ale import bude na serveru pokračovat. Opravdu změnit organizaci?",
    // Steps
    step1: "Nahrát soubor",
    step2: "Náhled a validace",
    step3: "Výsledek",
    stepOf: "Krok {current} z {total}",
    // Dropzone
    dropzoneTitle: "Přetáhněte CSV soubor sem",
    dropzoneSubtitle: "nebo klikněte pro výběr souboru",
    dropzoneHint: "Podporované formáty: UTF-8, CP1250 | Oddělovače: čárka, středník",
    downloadTemplate: "Stáhnout šablonu",
    selectFile: "Vybrat soubor",
    selectedFile: "Vybraný soubor",
    fileSize: "Velikost",
    changeFile: "Změnit soubor",
    uploadAndValidate: "Nahrát a validovat",
    // Preview
    previewTitle: "Náhled importu",
    summary: "Souhrn",
    totalRows: "Celkem řádků",
    validRows: "Platných",
    invalidRows: "Neplatných",
    duplicateRows: "Duplicit",
    warningRows: "S varováním",
    previewTable: "Náhled dat (prvních 50 řádků)",
    rowNumber: "Řádek",
    rowStatus: "Stav",
    rowData: "Data",
    // Row statuses
    statusValid: "Platný",
    statusInvalid: "Neplatný",
    statusDuplicate: "Duplicita",
    statusWarning: "Varování",
    // Validation settings
    validationSettings: "Nastavení validace",
    skipInvalidRows: "Přeskočit neplatné řádky",
    skipInvalidRowsHint: "{count} řádků bude přeskočeno",
    // Duplicate handling
    duplicateHandling: "Zpracování duplicit",
    duplicateModeSkip: "Přeskočit duplicity",
    duplicateModeUpdate: "Aktualizovat existující",
    duplicateModeFail: "Zastavit při duplicitě",
    duplicateOf: "Duplicita záznamu",
    // Buttons
    back: "Zpět",
    import: "Importovat",
    importCount: "Importovat ({count})",
    cancel: "Zrušit",
    done: "Hotovo",
    close: "Zavřít",
    // Progress
    progressTitle: "Probíhá import",
    progressSubtitle: "Prosím počkejte, data se importují...",
    processingRow: "Zpracovávám řádek {current} z {total}",
    estimatedTime: "Odhadovaný zbývající čas",
    cancelImport: "Zrušit import",
    cancelWarning: "Poznámka: Již importované řádky nebudou vráceny zpět.",
    // Result
    resultTitle: "Import dokončen",
    resultSuccess: "Import byl úspěšně dokončen",
    resultPartial: "Import dokončen s chybami",
    resultFailed: "Import selhal",
    resultCancelled: "Import zrušen",
    imported: "Importováno",
    skipped: "Přeskočeno",
    failed: "Selhalo",
    updated: "Aktualizováno",
    downloadErrors: "Stáhnout chyby (CSV)",
    errorsTitle: "Chyby v řádcích ({count})",
    errorsField: "Pole",
    errorsValue: "Hodnota",
    errorsMessage: "Chyba",
    errorsShownOf: "Zobrazeno prvních {shown} z {total} chyb — celý seznam stáhněte jako CSV.",
    viewInList: "Zobrazit v seznamu",
    importAnother: "Importovat další",
    noValidRows: "Žádné platné řádky k importu",
    // Errors
    fileTooLarge: "Soubor je příliš velký (max 5 MB)",
    invalidFileType: "Neplatný typ souboru (očekáváno .csv)",
    tooManyRows: "Příliš mnoho řádků (max 5000)",
    uploadError: "Chyba při nahrávání souboru",
    previewExpired: "Náhled vypršel, nahrajte soubor znovu",
    importInProgress: "Již probíhá jiný import",
    importCancelled: "Import zrušen",
    // Refused confirm (shown at the preview step); {count} = duplicates in the file
    uploadAgain: "Nahrát soubor znovu",
    confirmErrors: {
      previewExpired: "Náhled vypršel (platí 15 minut). Nahrajte soubor znovu.",
      anotherImportInProgress: "V organizaci už probíhá jiný import. Počkejte, až doběhne, a zkuste to znovu.",
      duplicateFound: "Soubor obsahuje duplicitní záznamy ({count}) a je zvoleno „Zastavit při duplicitě“. Zvolte jiné zpracování duplicit, nebo duplicity ze souboru odstraňte.",
      forbidden: "Nemáte oprávnění tento import potvrdit.",
      serverError: "Chyba serveru. Import se nemusel provést celý — než ho zopakujete, zkontrolujte seznam.",
      networkError: "Spojení se serverem selhalo. Než import zopakujete, zkontrolujte v seznamu, jestli se data už nenaimportovala.",
      confirmFailed: "Import se nepodařilo spustit.",
    },
    // Error codes (for backend error mapping)
    errors: {
      requiredField: "Povinné pole",
      invalidEmail: "Neplatný e-mail",
      invalidDate: "Neplatný formát data",
      invalidNumber: "Neplatné číslo",
      negativeNumber: "Číslo nesmí být záporné",
      positiveRequired: "Číslo musí být kladné",
      valueTooLong: "Hodnota je příliš dlouhá",
      duplicateFound: "Nalezena duplicita",
      invalidDocumentType: "Neplatný typ dokumentu",
      unknownField: "Neznámé pole",
      serverError: "Chyba serveru",
      quotaExceeded: "Překročena kvóta organizace",
      invalidCsvContent: "Neplatný obsah CSV",
      encodingError: "Chyba kódování souboru",
      fileTooLarge: "Soubor je příliš velký",
      tooManyRows: "Příliš mnoho řádků",
      invalidFileType: "Neplatný typ souboru",
      anotherImportInProgress: "Probíhá jiný import",
      previewExpired: "Náhled vypršel",
      forbidden: "Přístup odepřen",
      serverRestart: "Import přerušen (server restartován). Část řádků se mohla naimportovat — zkontrolujte seznam.",
      jobStatusUnavailable: "Stav importu se nepodařilo zjistit. Import mohl na serveru doběhnout celý nebo jen zčásti — zkontrolujte seznam.",
    },
    // Permissions
    noPermission: "Nemáte oprávnění importovat data. Kontaktujte správce organizace.",
    // Entity types
    entityTypes: {
      pilots: "piloti",
      aircraft: "letadla",
      batteries: "baterie",
      documents: "dokumenty",
    },
  },

  // SORA Pre-Assessment
  sora: {
    title: "Předběžné posouzení SORA",
    environment: "Typ prostředí",
    rural: "Venkov / Řídce osídlené",
    urban: "Město / Osídlené",
    
    // Core outputs - Professional aviation terminology
    estimatedSail: "Odhadovaná úroveň SAIL (předběžné posouzení)",
    sailLevel: "Odhadovaná úroveň SAIL",
    riskLevel: "Úroveň rizika",
    low: "Nízká",
    medium: "Střední",
    high: "Vysoká",
    
    // GRC / ARC - Standard SORA terminology
    grc: "Třída rizika na zemi (GRC)",
    arc: "Třída rizika ve vzduchu (ARC)",
    groundRisk: "Riziko na zemi",
    airRisk: "Riziko ve vzduchu",
    mitigated: "po mitigaci",
    reducedFrom: "Sníženo z",
    throughMitigations: "díky mitigačním opatřením",
    baseRiskTooltip: "Základní riziko ({0}) bylo sníženo o {1} stupeň díky:",
    
    // ARC Descriptions - Professional aviation language
    arcAtypical: "Atypický vzdušný prostor s řízeným provozem",
    arcLow: "Nízká pravděpodobnost střetu s pilotovaným letadlem",
    arcMedium: "Střední pravděpodobnost střetu s pilotovaným provozem",
    arcHigh: "Vysoká pravděpodobnost střetu; vyžaduje významná mitigační opatření",
    
    // Sections - Operational terminology
    inputsUsed: "Vstupní parametry posouzení",
    riskDrivers: "Faktory ovlivňující úroveň rizika",
    riskFactors: "Faktory zvyšující riziko",
    mitigationsApplied: "Aplikovaná mitigační opatření",
    uncertainty: "Nejistoty odhadu",
    uncertaintyFactors: "Nejistoty odhadu",
    
    // Confidence - Professional assessment language
    confidence: "Spolehlivost odhadu",
    confidenceHigh: "Vysoká spolehlivost",
    confidenceMedium: "Střední spolehlivost",
    confidenceLow: "Nízká spolehlivost",
    confidenceReliability: "Spolehlivost odhadu",
    moreCount: "+{count} dalších",
    
    // Mitigations grouped - SORA 2.5 M1/M2 terminology
    strategic: "Strategická opatření (M1)",
    technical: "Technická opatření (M2)",
    mitigationsStatus: "Mitigační opatření UA",
    
    // SORA 2.5 Mitigation categories
    m1a: "Úkryt (M1A) – osoby chráněny stavbami",
    m1b: "Provozní omezení (M1B) – vymezená oblast provozu",
    m1c: "Pozemní dohled (M1C) – vizuální sledování trasy letu",
    m2: "Technická mitigace (M2) – padák, FTS",
    
    // Containment (SORA 2.5)
    containmentLevel: "Úroveň containmentu",
    containmentRequired: "Containment vyžadován",
    containmentNone: "Nevyžadován",
    containmentLow: "Nízký",
    containmentMedium: "Střední",
    containmentHigh: "Vysoký",
    
    // SORA version
    soraVersion: "Verze SORA",
    soraNote: "Posouzení dle SORA 2.5",
    sora25Disclaimer: "Zjednodušené předběžné posouzení dle JARUS SORA 2.5 (platná od 29.9.2025 dle ED Decision 2025/018/R). Nenahrazuje formální SORA analýzu.",
    
    // Max speed
    maxSpeed: "Max. rychlost (m/s)",
    maxSpeedHelper: "Výrobcem deklarovaná maximální rychlost UA – vstup výpočtu GRC dle SORA 2.5",
    
    // Mitigation names - Exact UAS terminology (SORA 2.5)
    parachuteRecovery: "Padákový systém (M2)",
    flightTermination: "Systém ukončení letu – FTS (M2)",
    geoAwareness: "Geo-awareness (M1B)",
    remoteId: "Dálková identifikace (Remote ID)",
    visualLineOfSight: "Provoz ve VLOS",
    groundObservation: "Pozemní dohled (M1C)",
    sheltering: "Úkryt osob (M1A)",
    
    // Missing / Recommendations - Operational language
    missingRequirements: "Chybějící / doporučená opatření",
    recommendations: "Doporučená opatření",
    
    // Operational categories - EU regulation terminology
    openSpecificLow: "Open/Specific (nízké riziko)",
    specificStandard: "Specific (standardní povolení)",
    specificEnhanced: "Specific (rozšířené povolení) / Certified",
    
    // Assessment inputs - Professional input labels
    assessmentInputs: "Vstupní parametry",
    assessmentBasis: "Základ posouzení",
    operationType: "Typ operace",
    locationStatus: "Lokace",
    defined: "Definována",
    undefined: "Nedefinována",
    precision: "přesnost",
    aircraft: "UA",
    
    // Disclaimers - Clear professional disclaimer (SORA 2.5)
    disclaimer: "Toto je zjednodušené předběžné posouzení dle SORA 2.5 a nenahrazuje oficiální SORA analýzu.",
    disclaimerShort: "Předběžné posouzení dle SORA 2.5. Nenahrazuje oficiální analýzu.",
    noAssessment: "Nelze provést posouzení. Ujistěte se, že je přiřazen UA.",
    
    // Summary sentence parts - Natural Czech aviation language
    summaryEstimated: "Odhadovaná úroveň",
    summaryDueTo: "na základě",
    summaryUrbanEnv: "městského prostředí",
    summaryRuralEnv: "venkovského prostředí",
    summaryBvlos: "operace BVLOS",
    summaryAirportProximity: "blízkosti letiště",
    summaryMitigationsReduce: "Mitigační opatření snižují riziko na zemi",
    summaryMitigationsApplied: "mitigační opatření aplikována",
    
    // Data source indicators
    dataSourceLive: "Živá data vzdušného prostoru",
    dataSourceStatic: "Statická data (offline režim)",
    dataSourceTooltip: "OpenAIP API nedostupné – používá se zjednodušená databáze letišť",
    
    // Legacy drone warnings (priority-based) - Czech professional aviation language
    legacyHighRiskNoRemoteId: "⚠️ Dron bez označení C0-C6 a bez Remote ID v prostoru s vysokým rizikem – tato kombinace vyžaduje pozornost před zahájením provozu. Doporučujeme konzultaci s příslušným úřadem nebo info@aeroway.cz",
    legacyUrbanNoRemoteId: "⚠️ Dron bez označení C0-C6 a bez Remote ID v městském prostředí – provoz může vyžadovat zvláštní povolení. Ověřte situaci v DroneMap nebo se obraťte na příslušný úřad. Potřebujete pomoct s vyřízením povolení nebo analýzou provozu? Náš tým vám rád pomůže – info@aeroway.cz",
    legacyUrban: "⚠️ Dron bez označení C0-C6 v městském prostředí – provoz může vyžadovat zvláštní povolení. Ověřte situaci v DroneMap nebo se obraťte na příslušný úřad. Potřebujete pomoct s vyřízením povolení nebo analýzou provozu? Náš tým vám rád pomůže – info@aeroway.cz",
    legacyRuralInfo: "ℹ️ Dron bez označení C0-C6 – v řídce osídlených oblastech obecně bez omezení, mějte k dispozici dokumentaci k UA. Pro upřesnění kontaktujte info@aeroway.cz",
    
    // PDF Export
    exportPdf: "Exportovat SORA PDF",
    pdfGenerated: "SORA PDF vygenerováno",
    
    // Risk factor translations (from backend)
    riskAirspaceAssessmentCaution: "Hodnocení vzdušného prostoru: pozor",
    riskAirspaceAssessmentHighRisk: "Hodnocení vzdušného prostoru: vysoké riziko",
    riskLocationPrecisionLow: "Přesnost lokace je nízká – ověřte přesnou oblast mise",
    riskUrbanEnvironment: "Městské prostředí zvyšuje riziko na zemi",
    riskBvlosOperation: "Operace BVLOS zvyšuje riziko ve vzduchu",
    riskProximityToAirport: "Blízkost letiště {airport} ({distance} km)",
    
    // Mitigation translations (from backend)
    mitParachuteReduces: "Padákový systém (M2) snižuje závažnost dopadu na zem",
    mitFtsControlled: "FTS (M2) umožňuje řízené ukončení letu",
    mitGeoAwarenessPrevents: "Geo-awareness (M1B) zabraňuje překročení hranic vzdušného prostoru",
    mitRemoteIdEnhances: "Remote ID zvyšuje situační povědomí",
    
    // Uncertainty translations (from backend)
    uncLocationDefined: "Lokace definována s nízkou přesností",
    uncNoLocationCoordinates: "Souřadnice lokace nebyly zadány",
    
    // Confidence reason translations
    plusMore: "+{count} další",
  },

  // Airspace Advisory
  airspace: {
    title: "Poradce vzdušného prostoru",
    highRisk: "Vysoké riziko",
    caution: "Zvýšená opatrnost",
    noIssues: "Bez známých problémů",
    unknown: "Neznámý stav",
    reasons: "Hodnocení",
    recommendations: "Doporučení",
    disclaimer: "Toto je zjednodušený poradce a nenahrazuje oficiální ověření vzdušného prostoru (např. DroneMap).",
    noAdvisory: "Nastavte souřadnice pro hodnocení vzdušného prostoru",
    nearestAirport: "Nejbližší letiště",
    distanceKm: "km",
    confidence: "Důvěryhodnost",
    locationPrecision: "Přesnost lokace",
  },

  // Map Layers
  map: {
    pointsOfInterest: "Body zájmu",
    pointsOfInterestDescription: "Nemocnice, věznice, jaderná zařízení, vládní budovy",
    verifyRestrictions: "Ověřte místní omezení před letem",
    informationalNote: "Informativní zobrazení - nenahrazuje oficiální zdroje",
    distance: "Vzdálenost",
    categories: {
      hospital: "Nemocnice",
      prison: "Věznice",
      nuclear: "Jaderné zařízení",
      government: "Vládní budova",
      military: "Vojenský objekt"
    },
    legend: {
      title: "Vrstvy mapy",
      prohibited: "Zakázané (vč. LKP)",
      poi: "Body zájmu"
    }
  },

  // Mission Lifecycle
  lifecycle: {
    status: "Stav",
    draft: "Návrh",
    ready: "Připraveno",
    active: "Probíhá",
    completed: "Dokončeno",
    planning: "Plánování",
    activeToday: "Dnes (Probíhající)",
  },

  // Daily Ops Dashboard
  dailyOps: {
    title: "Denní přehled operací",
    subtitle: "Přehled dnešních operací",
    totalToday: "Celkem dnes",
    todaysMissions: "Dnešní mise",
    operationalAlerts: "Provozní upozornění",
    quickActions: "Rychlé akce",
    viewAllMissions: "Zobrazit všechny mise",
    viewHistory: "Historie misí",
    noMissionsToday: "Na dnes nejsou naplánované žádné mise",
    noAlerts: "Žádná provozní upozornění",
    complianceIssues: "Problémy compliance",
    markCompleted: "Označit jako dokončené",
    // New polish pass translations
    needsAttention: "Vyžaduje pozornost",
    missionsNeedWork: "misí vyžaduje práci",
    allClear: "vše v pořádku",
    readyToFly: "Připraveno k letu",
    missionsReady: "misí připraveno nebo probíhá",
    completedToday: "dokončeno dnes",
    actionRequired: "Vyžadována akce",
    fix: "Opravit",
    viewAllIssues: "Zobrazit všechny problémy",
    more: "dalších",
    activeAndReady: "Aktivní a připravené",
    inProgress: "Probíhá",
    readyToStart: "Připraveno ke startu",
    noReadyMissions: "Žádné mise připravené k letu",
    prepareMission: "Připravit misi",
    noDrafts: "Žádné mise v plánování",
    scheduleHint: "Naplánujte misi pro začátek",
    noPilot: "Nepřiřazen pilot",
    noAircraft: "Nepřiřazen dron",
    unassigned: "Nepřiřazeno",
    blockers: "Blokuje",
    missionCompleted: "Mise označena jako dokončená",
  },

  // Mission Detail - Polish pass
  missionDetail: {
    blockedBy: "Mise nemůže být označena jako připravená kvůli:",
    fixIssues: "Opravit problémy",
    checklistIncomplete: "Checklist nedokončen",
  },

  // Mission History
  missionHistory: {
    title: "Historie misí",
    subtitle: "Zobrazit dokončené a minulé mise",
    searchPlaceholder: "Hledat mise...",
    filterByMonth: "Filtrovat podle měsíce",
    filterByOrg: "Filtrovat podle organizace",
    missionsFound: "nalezených misí",
    noHistory: "Nenalezena žádná historie misí",
  },

  // Mission Calendar
  missionCalendar: {
    title: "Kalendář misí",
    subtitle: "Vizuální přehled naplánovaných misí",
    today: "Dnes",
    more: "další",
    noMissions: "Žádné naplánované mise",
    clickToView: "Klikněte pro zobrazení detailů",
  },

  // None option
  none: "Žádný",
  
  // U-Space fields
  uSpace: {
    operatorId: "EASA Operator ID",
    operatorIdHelper: "Registrační číslo operátora z EASA/ÚCL registrace (např. CZE-OP-XXXXXX)",
    sectionTitle: "U-Space & Flight Plan",
    sectionSubtitle: "Volitelné údaje pro operace v U-Space zónách",
    etot: "Plánovaný čas vzletu (ETOT)",
    etotHelper: "Estimated Time of Take-Off – vyžadováno pro U-Space operace",
    eldt: "Plánovaný čas přistání (ELDT)",
    eldtHelper: "Estimated Landing Time",
    uSpaceZone: "U-Space zóna",
    uSpaceAuthorization: "U-Space autorizace",
    uSpaceNotRequired: "Nevyžadováno",
    uSpaceReadyToSubmit: "Připraveno k odeslání",
    uSpaceApiNotConnected: "API nepřipojeno",
    uSpaceReadiness: "U-Space připravenost",
    uSpaceReadinessLow: "Nízká připravenost",
    uSpaceReadinessMedium: "Střední připravenost",
    uSpaceReadinessHigh: "Vysoká připravenost",
  },
  
  // SAIL Status Banner
  sailBanner: {
    openCategory: "Open kategorie",
    specificAuthorization: "Specific autorizace",
    whySailLevel: "Proč SAIL",
    insideCtr: "Uvnitř CTR",
    elevatedAirspaceRisk: "Zvýšené riziko vzdušného prostoru",
    nearAirport: "Blízko letiště",
    urbanArea: "Městská / zastavěná oblast",
    bvlosOperation: "BVLOS operace",
    highGrc: "Vysoké pozemní riziko",
    openCategoryStatus: "Open kategorie / STS scénář",
    specificRequired: "Vyžaduje Specific autorizaci ÚCL",
    openCheckMate: "Otevřít CheckMate",
    calculating: "Vyhodnocování...",
    assessmentInProgress: "Probíhá hodnocení...",
  },
  
  // ARC podle SORA 2.5 Figure 6 nad zeměpisnými zónami ŘLP (banner, rámeček předběžnosti, karta
  // „Vzdušný prostor“, CheckMate, prostředí ve formuláři mise)
  arcDisplay: {
    airspaceUndetermined: "Vzdušný prostor nelze určit — počítá se nejhorší ARC",
    highRiskAirportCtr: "Okolí letiště v řízeném prostoru (CTR/MCTR)",
    highRiskAbove500Ctr: "Nad 500 ft AGL v CTR/MCTR",
    highRiskAbove1000: "Nad 1000 ft AGL (řízený prostor třídy E)",
    withoutDeclaration: "{reason} (bez deklarace ARC-a)",
    atsCoordination: "V CTR/MCTR je pravděpodobně nutná koordinace s ATS (telefonicky nebo trvalé rádiové spojení).",
    atcAgreement: "Ve vzdušném prostoru ARC-d může být nutná dohoda s ATC (SORA 2.5 §4.5.4).",
    tmpr: "BVLOS — požadovaná výkonnost taktické mitigace (TMPR, SORA 2.5 tabulka 6): {level}",
    tmprLevels: { high: "vysoká", medium: "střední", low: "nízká", none: "žádná" },
    provisionalAirspaceTitle: "Vzdušný prostor nelze určit — počítá se nejhorší ARC",
    provisionalAtypicalAcceptedTitle: "ARC-a z deklarace provozovatele — posoudí Úřad",
    provisionalAtypicalIgnoredTitle: "Deklarace ARC-a se ve výpočtu nezohlednila",
    provisionalSimplifiedTitle: "Předběžný odhad ze zjednodušeného výpočtu",
    dataSourceRlp: "Zeměpisné zóny ŘLP",
    dataSourceRlpTooltip: "Stav podle zeměpisných zón UAS ŘLP nad celým operačním objemem mise (oblast letu a ochranný prostor 1:1 podle max. výšky), SORA 2.5 Figure 6.",
    fastTrackStaleTitle: "Dříve vybraný fast-track je zastaralý",
    fastTrackStaleArc: "Třídu rizika vzdušného prostoru (ARC) nyní nelze určit — nový výběr fast-tracku by byl odmítnut.",
    // Řádky vysvětlení ARC (důvody karty „Vzdušný prostor“, „Proč tato úroveň SAIL?“)
    aec: {
      1: "okolí letiště/heliportu v prostoru třídy B, C nebo D",
      2: "nad 500 ft AGL v Mode-C veil nebo TMZ",
      3: "nad 500 ft AGL v řízeném vzdušném prostoru",
      4: "nad 500 ft AGL v neřízeném prostoru nad městskou oblastí",
      5: "nad 500 ft AGL v neřízeném prostoru nad venkovskou oblastí",
      6: "okolí letiště/heliportu v prostoru třídy E, F nebo G",
      7: "pod 500 ft AGL v Mode-C veil nebo TMZ",
      8: "pod 500 ft AGL v řízeném vzdušném prostoru",
      9: "pod 500 ft AGL v neřízeném prostoru nad městskou oblastí",
      10: "pod 500 ft AGL v neřízeném prostoru nad venkovskou oblastí",
      11: "nad FL600",
      12: "atypický vzdušný prostor — ARC-a z deklarace provozovatele, posoudí Úřad",
    },
    lineAec: "AEC {aec}: {description} → počáteční {initial}",
    lineAecFinal: "AEC {aec}: {description} → počáteční {initial}, výsledná {final}",
    lineWorstCase: "Nejhorší případ — vzdušný prostor nelze určit → {arc}",
    lineVolume: "Operační objem: oblast letu + ochranný prostor {contingency} m (1:1), vrchol {top} m AGL",
    lineVolumeAltitudeMissing: " (max. výška chybí — nejhorší případ)",
    lineZone: "Zóna {ident} ({layer}, {role}): {limit}",
    zoneRoleCtr: "CTR/MCTR třídy D",
    zoneRoleAirport: "okolí letiště/heliportu",
    lineMoreZones: "… a další zóny: {count}",
    lineData: "Data zón ŘLP k {date}: vydání {release}; hranice {boundary}; data {fingerprint}",
    boundaryNone: "neimportována",
    showAllLines: "Zobrazit vše ({count})",
    showFewerLines: "Zobrazit méně",
    lineDataLater: "K datu mise nejsou platná data zón; použita nejstarší data, platná později ({layers})",
    recResolve: "Odstraňte výše uvedené důvody — dokud nelze ARC určit, misi nelze schválit ani na ni použít fast-track.",
    recVerifyAuthorization: "Před zahájením ověřte požadavky na povolení.",
    recReviewRestrictions: "Zkontrolujte místní omezení a zvažte mitigační opatření.",
    recStandardChecks: "Platí standardní předletové kontroly a postupy.",
    // Prostředí ve formuláři mise
    environmentManualHelp: "Zůstává řídicím vstupem SORA. Podrobné ruční posouzení hustoty obyvatel (CENSUS/LUISA) lze doplnit později v detailu mise. Kontrolovanou pozemní oblast deklarujte v detailu mise (Deklarace operačního prostoru) se zdůvodněním.",
    environmentAutoTitle: "Určí se automaticky ze zeměpisných zón ŘLP",
    environmentAutoHelp: "Při uložení mise: operační objem zasahuje do hustě osídleného prostoru (ŘLP LKR316) → město, jinak venkov. Kontrolovanou pozemní oblast deklarujte v detailu mise (Deklarace operačního prostoru).",
    environmentAutoStored: "Uloženo: {value}",
    environmentAutoFallbackLabel: "Použije se, jen když vzdušný prostor nelze určit (např. oblast mimo ČR)",
    environmentSettingsUnknown: "Nastavení serveru se načítá nebo se ho nepodařilo načíst, takže není jisté, zda se prostředí určí automaticky ze zón ŘLP; pokud se nastavení nenačte, obnovte stránku.",
  },

  // Deklarace atypického vzdušného prostoru (ARC-a) v detailu mise
  atypicalDeclaration: {
    title: "Deklarace atypického vzdušného prostoru (ARC-a) — posoudí Úřad",
    subtitle: "Provozovatel deklaruje atypický vzdušný prostor z jednoho z důvodů a)–e). Důvody a), c) a d) server ověří nad zeměpisnými zónami ŘLP; deklaraci posoudí Úřad.",
    notDeclared: "Není deklarováno",
    reasonLabel: "Důvod",
    reasons: {
      tsa_tra: "a) let v rezervovaném prostoru TSA/TRA",
      notam: "b) prostor vyhrazený NOTAM",
      prohibited_area_permit: "c) let v zakázaném prostoru s oprávněním",
      very_low_altitude: "d) let do 30 m AGL mimo okolí letiště",
      obstacle_proximity: "e) let u umělé překážky (nejvýše 15 m nad ní a 30 m od ní)",
    },
    reasonHints: {
      tsa_tra: "Do poznámky uveďte odkaz na rezervaci AUP/UUP.",
      notam: "Do poznámky uveďte číslo NOTAM.",
      prohibited_area_permit: "Do poznámky uveďte číslo oprávnění.",
      very_low_altitude: "Do 30 m AGL, mimo okolí letiště. Poznámka je nepovinná.",
      obstacle_proximity: "Překážka ≤ 15 m nad, ≤ 30 m od — do poznámky popište překážku (výška letu nad ní a vzdálenost od ní).",
    },
    noteLabel: "Poznámka",
    notePlaceholder: "Odkaz, číslo nebo popis podle zvoleného důvodu…",
    noteRequired: "Poznámka je pro zvolený důvod povinná.",
    noteTooLong: "Poznámka může mít nejvýše {max} znaků.",
    reasonRequired: "Vyberte důvod deklarace.",
    declare: "Deklarovat",
    edit: "Upravit",
    save: "Uložit",
    saving: "Ukládám...",
    cancel: "Zrušit",
    remove: "Odebrat deklaraci",
    removeConfirm: "Opravdu odebrat deklaraci atypického vzdušného prostoru (ARC-a)?",
    saved: "Deklarace ARC-a uložena",
    removed: "Deklarace ARC-a odebrána",
    saveError: "Deklaraci ARC-a se nepodařilo uložit",
    removeError: "Deklaraci ARC-a se nepodařilo odebrat",
    conflict: "Misi mezitím změnil jiný uživatel — údaje se znovu načetly, zkuste to prosím znovu.",
    declaredAt: "Deklarováno",
    declaredBy: "Deklaroval(a)",
    declaredByYou: "vy",
    declaredByOther: "jiný uživatel ({id}…)",
    evaluation: "Vyhodnocení",
  },

  // Wave 2.5: Operator Declarations
  operatorDeclarations: {
    title: "Deklarace operačního prostoru",
    subtitle: "Operátor může deklarovat specifické podmínky ovlivňující GRC",
    gatheringLabel: "Shromáždění osob",
    gatheringDescription: "Operace probíhá v oblasti se shromážděním osob (koncert, sportovní akce, demonstrace apod.)",
    gatheringWarning: "Zvyšuje riziko na nejvyšší možnou úroveň (GRC-7, GRC-8, nebo mimo rozsah SORA — podle rozměru a rychlosti dronu)",
    controlledLabel: "Kontrolovaná pozemní oblast",
    controlledDescription: "Operátor kontroluje přístup do letové oblasti (staveniště, uzavřený areál, vojenský prostor apod.)",
    controlledBenefit: "Aktivace umožňuje GRC-1-2 (nejnižší riziko)",
    reasonLabel: "Odůvodnění deklarace",
    reasonPlaceholder: "Popište konkrétní okolnosti...",
    edit: "Upravit",
    save: "Uložit",
    cancel: "Zrušit",
    saving: "Ukládám...",
    saved: "Deklarace uložena",
    error: "Chyba při ukládání",
    noDeclarations: "Žádné deklarace nejsou aktivní",
    declaredAt: "Deklarováno",
    grcReduced: "GRC sníženo",
  },
  
  // CheckMate
  soraAssistant: {
    title: "CheckMate",
    subtitle: "Váš průvodce autorizací mise",
    tabSubtitle: "AI průvodce autorizací",
    // CheckMate tab CTA
    ctaBannerSailHigh: "Tato mise vyžaduje Specific autorizaci ÚCL",
    ctaBannerSailHighAction: "CheckMate vám pomůže připravit dokumentaci",
    ctaBannerSailLow: "Doporučujeme zkontrolovat compliance dokumentaci",
    ctaBannerOpenCheckMate: "Otevřít CheckMate",
    ctaLaunch: "Spustit CheckMate",
    // Status badges
    statusReady: "Připraveno",
    statusStepsRemaining: "kroky",
    statusActionNeeded: "Akce nutná",
    // Mode switcher
    modeGenerator: "Generátor",
    modeReview: "Review",
    reviewSubtitle: "Nechte AI posoudit váš dokument",
    // Review mode
    reviewTitle: "Review dokumentů",
    reviewDesc: "Nechte AI posoudit váš ConOps nebo OM dle SORA 2.5 a EU 2019/947",
    uploadDocForReview: "Nahrát dokument k posouzení",
    selectFile: "Vybrat soubor",
    docType: "Typ:",
    startReview: "Spustit review",
    reviewingDoc: "Probíhá analýza dokumentu...",
    reviewComplete: "Review dokončen",
    evaluatedAgainst: "Posouzeno dle:",
    compliantItems: "V pořádku",
    missingItems: "Chybí nebo nesprávně",
    recommendationsTitle: "Doporučení",
    needHelpWithFixes: "Potřebujete pomoc s opravami?",
    teamCanHelp: "Náš tým vám pomůže s přípravou dokumentace.",
    downloadReport: "Stáhnout review report",
    uploadNewDoc: "Nahrát opravený dokument",
    // Combined document support
    uploadCombined: "Nahrát kombinovaný ConOps+OM",
    detectedType: "Detekovaný typ:",
    combinedDoc: "ConOps + OM (kombinovaný)",
    overallScore: "Celkové hodnocení",
    conopsSection: "ConOps sekce",
    omSection: "OM sekce",
    useDetected: "Použít detekovaný",
    autoDetect: "Automaticky",
    // Mission context toggle
    missionContextAvailable: "Mise je k dispozici jako kontext",
    useMissionSoraContext: "Použít SORA data mise jako kontext",
    reviewWithoutMission: "Dokument bude posouzen pouze dle knowledge base",
    // Generator steps
    step1Title: "Diagnóza",
    step2Title: "Optimalizace",
    step3Title: "Akční plán",
    currentAssessment: "Aktuální hodnocení mise",
    specificAuth: "Specific (Standardní autorizace)",
    openCategory: "Open kategorie",
    certifiedCategory: "Certified kategorie",
    environmentWarning: "Varování prostředí",
    whySail: "Proč je SAIL na této úrovni?",
    showOptimizations: "Zobrazit optimalizace",
    howToReduce: "Jak snížit SAIL?",
    quickWins: "Rychlé výhry",
    recommended: "Doporučeno",
    otherOptions: "Další možnosti",
    selectOptimization: "Vybrat",
    deselectOptimization: "Zrušit",
    selectedOptimizations: "Vybrané optimalizace",
    newSailAfter: "Nový SAIL po aplikaci",
    back: "Zpět",
    showActionPlan: "Zobrazit akční plán",
    actionPlanTitle: "Akční plán pro dosažení",
    goal: "Cíl",
    step: "Krok",
    category: "Kategorie",
    estimatedTime: "Odhadovaný čas",
    needHelp: "Potřebujete pomoc?",
    teamHelp: "Náš tým vyřídí autorizaci za vás",
    saveAsPdf: "Uložit jako PDF",
    noImprovements: "Žádná vylepšení nejsou možná",
    noImprovementsDesc: "Aktuální konfigurace je již optimalizována pro tento vzdušný prostor.",
    effort: "Úsilí",
    effortLow: "Nízké",
    effortMedium: "Střední",
    effortHigh: "Vysoké",
    time: "Čas",
    immediate: "Ihned",
    shortTerm: "1-2 dny",
    longTerm: "1-2 týdny",
    sailImprovement: "úroveň",
    sailImprovements: "úrovně",
    authNeeded: "Vyžadována autorizace",
    equipmentCategory: "Vybavení",
    flightParamsCategory: "Parametry letu",
    authCategory: "Autorizace",
    docCategory: "Dokumentace",
    airspaceFactors: "Faktory vzdušného prostoru",
    currentEquipment: "Aktuální vybavení",
    parachute: "Padák",
    fts: "FTS",
    geoAwareness: "Geo-awareness",
    remoteId: "Remote ID",
    noOptSelected: "Žádné optimalizace nevybrány",
    selectAtLeast: "Vyberte alespoň jednu optimalizaci pro zobrazení akčního plánu",
    // Názvy optimalizací
    reduceAltitudeTo: "Snížit maximální výšku na",
    lowerAltitudeReduces: "Nižší výška snižuje pozemní riziko",
    addParachute: "Přidat padákový záchranný systém",
    parachuteReduces: "Padák snižuje energii dopadu",
    addFts: "Přidat systém ukončení letu (FTS)",
    ftsEnables: "FTS umožňuje kontrolované ukončení letu",
    addGeoAwareness: "Přidat geo-awareness systém",
    geoAwarenessProvides: "Geo-awareness poskytuje ochranu hranic vzdušného prostoru",
    geoAwarenessNoReduction: "Geo-awareness poskytuje ochranu hranic, ale nesníží ARC uvnitř CTR/omezeného prostoru",
    useDrone: "Použít",
    lighterDrone: "Lehčí dron s jiným vybavením",
    changeToVlos: "Změnit na VLOS operaci",
    vlosLowerRisk: "Operace v přímém dohledu má nižší riziko",
    envMismatch: "Detekován nesoulad prostředí",
    // Důvody vzdušného prostoru
    insideCtr: "Uvnitř CTR",
    nearInternationalAirport: "Blízko mezinárodního letiště",
    nearRegionalAirport: "Blízko regionálního letiště",
    highRiskAirspace: "Detekována vysoce riziková zóna vzdušného prostoru",
    // Kroky akčního plánu
    installParachute: "Nainstalovat padákový záchranný systém",
    contactTechnician: "Kontaktujte certifikovaného technika pro instalaci a testování před misí",
    installFts: "Nainstalovat systém ukončení letu",
    ftsCertified: "FTS musí být certifikován a otestován. Může vyžadovat aktualizaci firmware.",
    enableGeoAwareness: "Aktivovat funkci geo-awareness",
    checkDroneSettings: "Zkontrolujte nastavení dronu nebo nainstalujte modul geo-awareness",
    reduceAltitude: "Snížit maximální výšku",
    updateMissionParams: "Aktualizujte parametry mise a ujistěte se, že tato výška splňuje provozní požadavky",
    switchToDrone: "Přepnout na",
    useAlternativeDrone: "Použít alternativní dron z flotily",
    changeOpType: "Změnit typ operace na VLOS",
    redesignMission: "Přepracujte misi tak, aby byl zachován přímý dohled",
    obtainAuthorization: "Získat autorizaci vzdušného prostoru",
    ctrRequiresCoordination: "Operace v CTR/omezeném prostoru vyžaduje koordinaci s ATC. Připravte dokumentaci ConOps.",
    combinedSail: "Kombinovaný SAIL",
    withSelectedOptimizations: "s vybranými optimalizacemi",
    // Aplikovat změny
    applyChanges: "Aplikovat změny",
    confirmApplyTitle: "Potvrdit změny",
    confirmApplyDesc: "Budou změněny tyto hodnoty mise:",
    maxAltitudeLabel: "Max. výška letu",
    aircraftLabel: "Dron",
    overwriteWarning: "Tyto změny přepíší aktuální hodnoty mise.",
    confirmAndSave: "Potvrdit a uložit",
    applying: "Aplikuji...",
    changesApplied: "Změny úspěšně aplikovány",
    applyError: "Změny se nepodařilo aplikovat",
    updatedBySora: "Upraveno CheckMate",
    changeDismissed: "Indikátor změny skryt",
    dismissError: "Nepodařilo se skrýt změnu",
    // Vrátit změny
    undoTitle: "Vrátit změnu",
    revert: "Vrátit",
    changeReverted: "Změna úspěšně vrácena",
    undoError: "Nepodařilo se vrátit změnu",
    // Step 4 - Compliance
    step4Title: "Compliance",
    specificAuthRequired: "Tato operace vyžaduje Specific autorizaci",
    prepareComplianceDocs: "Připravte compliance dokumenty pro ÚCL",
    continueToCompliance: "Pokračovat ke compliance dokumentům",
    complianceDocs: "Compliance",
    compliance: {
      stepTitle: "Krok 4: Compliance dokumenty",
      stepSubtitle: "Připravte dokumentaci pro ÚCL",
      readiness: "Připravenost",
      soraComplete: "SORA 2.5 posouzení dokončeno",
      missionComplete: "Data mise kompletní",
      omUploaded: "OM šablona – nahrána",
      omNotUploaded: "OM šablona – nenahrána",
      conopsUploaded: "ConOps šablona – nahrána",
      conopsNotUploaded: "ConOps šablona – nenahrána",
      yourTemplates: "Vaše šablony",
      uploadOm: "Nahrát OM šablonu",
      uploadConops: "Nahrát ConOps šablonu",
      supportedFormats: "Podporované formáty: .pdf, .docx",
      generateDocuments: "Generovat dokumenty",
      generating: "Generuji...",
      generatingConops: "AI agent analyzuje data mise a knowledge base...",
      generatingOm: "Vyplňuji Operations Manual šablonu...",
      generatingUcl: "Generuji kompletní UCL balík...",
      generateConops: "Generovat ConOps",
      fillOm: "Vyplnit Operations Manual",
      generateUcl: "Generovat UCL balík",
      // Progress steps
      progressStep1: "Analyzuji data mise...",
      progressStep2: "Konzultuji knowledge base...",
      progressStep3: "Generuji sekce dokumentu...",
      progressStep4: "Kontroluji soulad se SORA 2.5...",
      progressStep5: "Finalizuji dokument...",
      conopsGenerated: "ConOps vygenerován",
      omGenerated: "Operations Manual vyplněn",
      uclGenerated: "UCL balík vygenerován",
      usedRegulatoryDocs: "Použité regulatorní dokumenty:",
      missingFields: "Chybějící pole",
      more: "další",
      preview: "Náhled dokumentu",
      downloadWord: "Stáhnout jako Word",
      downloadPdf: "Stáhnout jako PDF",
      regenerate: "Přegenerovat",
      regulatoryBase: "Regulatorní základna:",
      documentPreview: "Náhled dokumentu",
      // Step 4 UX improvements
      defaultTemplateNote: "Vlastní šablona nenahrána – bude použit výchozí vzor",
      skipCompliance: "Compliance dokumenty pro tuto misi nepotřebuji → Přeskočit",
      backToActionPlan: "Zpět na akční plán",
      backToMissionDetail: "Zpět na detail mise",
    },
  },
  
  // Knowledge Base Admin
  knowledgeBaseAdmin: {
    docTypes: {
      eu_regulation: "EU nařízení",
      czech_regulation: "Český předpis",
      sora_methodology: "SORA metodika",
      reference_document: "Referenční dokument",
      reference_document_desc: "Referenční dokument (ConOps, OM, provozní dokumenty)",
    },
    stats: {
      referenceDocuments: "Referenční dokumenty",
    },
    toasts: {
      fetchError: "Nepodařilo se načíst dokumenty",
      unsupportedFormat: "Nepodporovaný formát. Použijte .pdf, .docx, .txt nebo .md",
      requiredFields: "Vyplňte všechna povinná pole",
      uploaded: "Dokument nahrán: {message}",
      uploadError: "Nahrání selhalo",
      deactivated: "Dokument deaktivován",
      activated: "Dokument aktivován",
      toggleError: "Operace selhala",
      deleted: "Dokument smazán",
      deleteError: "Smazání selhalo",
    },
  },

  // Insurance Management
  insurance: {
    title: "Správa pojištění",
    subtitle: "Pojistné smlouvy flotily",
    addPolicy: "Přidat pojistku",
    editPolicy: "Upravit pojistku",
    deletePolicy: "Smazat pojistku",
    noPolicies: "Žádné pojistné smlouvy",
    noPoliciesDesc: "Přidejte první pojistnou smlouvu pro vaši flotilu",
    // Table columns
    policyNumber: "Číslo pojistky",
    insurer: "Pojišťovna",
    coverageType: "Typ krytí",
    coverageAmount: "Výše krytí",
    validFrom: "Platnost od",
    validUntil: "Platnost do",
    coveredAircraft: "Krytá letadla",
    allAircraft: "Všechna letadla",
    status: "Status",
    actions: "Akce",
    document: "Dokument",
    notes: "Poznámky",
    // Coverage types
    liability: "Odpovědnost",
    hull: "Kasko",
    both: "Odpovědnost + Kasko",
    // Status badges
    valid: "Platné",
    expiringSoon: "Vyprší brzy",
    expired: "Vypršelo",
    daysRemaining: "dní zbývá",
    daysAgo: "dní po expiraci",
    // Stats
    totalPolicies: "Celkem pojistek",
    validPolicies: "Platné pojistky",
    expiringPolicies: "Brzy vyprší",
    expiredPolicies: "Vypršelé",
    highestCoverage: "Nejvyšší krytí",
    earliestExpiry: "Nejbližší expirace",
    // Form
    policyDetails: "Údaje o pojistce",
    selectCoverageType: "Vyberte typ krytí",
    amountInEur: "Částka v EUR",
    selectAircraft: "Vyberte letadla (prázdné = všechna)",
    uploadPdf: "Nahrát PDF pojistky",
    dropPdfHere: "Přetáhněte PDF sem nebo klikněte",
    pdfUploaded: "PDF nahráno",
    replacePdf: "Nahradit PDF",
    viewPdf: "Zobrazit PDF",
    // Warnings
    coverageWarning: "Pokrytí pod minimem EU 2019/947",
    coverageMinimum: "Minimální požadované krytí: €750,000",
    noValidInsurance: "Žádné platné pojištění",
    insuranceExpiresSoon: "Pojištění vyprší za {days} dní",
    insuranceExpired: "Pojištění vypršelo",
    // Confirmation
    deleteConfirm: "Opravdu chcete smazat tuto pojistku?",
    deleteWarning: "Tato akce je nevratná.",
    // Success messages
    policyCreated: "Pojistka vytvořena",
    policyUpdated: "Pojistka aktualizována",
    policyDeleted: "Pojistka smazána",
    documentUploaded: "Dokument nahrán",
    // Filter
    filterByStatus: "Filtrovat podle stavu",
    allStatuses: "Všechny stavy",
  },

  // Operational Authorizations
  authorizations: {
    title: "Operační autorizace",
    subtitle: "Autorizace pro operace ve Specifické kategorii",
    addAuthorization: "Přidat autorizaci",
    editAuthorization: "Upravit autorizaci",
    deleteAuthorization: "Smazat autorizaci",
    revokeAuthorization: "Zrušit autorizaci",
    noAuthorizations: "Žádné operační autorizace",
    noAuthorizationsDesc: "Přidejte první autorizaci pro vaši organizaci",
    // Table columns
    referenceNumber: "Referenční číslo",
    authorizationType: "Typ autorizace",
    authTitle: "Název",
    issuingAuthority: "Vydávající úřad",
    issuedAt: "Datum vydání",
    validFrom: "Platnost od",
    validUntil: "Platnost do",
    conditions: "Podmínky",
    sailLevels: "Úrovně SAIL",
    coveredAircraft: "Krytá letadla",
    allAircraft: "Všechna letadla",
    status: "Status",
    document: "Dokument",
    notes: "Poznámky",
    // Authorization types (new enum values)
    types: {
      STS_01: "STS-01 (VLOS nad kontrolovaným prostorem)",
      STS_02: "STS-02 (BVLOS nad řídce osídleným)",
      PDRA_S01: "PDRA-S01",
      PDRA_S02: "PDRA-S02",
      PDRA_G01: "PDRA-G01",
      LUC: "LUC (Light UAS Operator Certificate)",
      OPERATIONAL_AUTHORIZATION: "Operační autorizace",
      CUSTOM: "Vlastní"
    },
    // Status badges (all enum values including application stages)
    statuses: {
      draft: "Koncept",
      submitted: "Podáno",
      under_review: "V posouzení",
      needs_amendment: "Vyžaduje úpravu",
      active: "Aktivní",
      expired: "Vypršela",
      suspended: "Pozastavena",
      revoked: "Zrušena"
    },
    // Legacy status badges (for backward compatibility)
    status_active: "Aktivní",
    status_expired: "Vypršelá",
    status_suspended: "Pozastavená",
    status_revoked: "Zrušená",
    status_draft: "Koncept",
    status_submitted: "Podáno",
    status_under_review: "V posouzení",
    status_needs_amendment: "Vyžaduje úpravu",
    daysRemaining: "dní zbývá",
    daysAgo: "dní po expiraci",
    // Stats
    totalAuthorizations: "Celkem autorizací",
    activeAuthorizations: "Aktivní",
    expiringAuthorizations: "Brzy vyprší",
    expiredAuthorizations: "Vypršelé",
    suspendedAuthorizations: "Pozastavené",
    revokedAuthorizations: "Zrušené",
    coveredSailLevels: "Pokryté SAIL úrovně",
    // Form
    authorizationDetails: "Údaje o autorizaci",
    selectType: "Vyberte typ autorizace",
    conditionsHint: "Zadejte podmínku a stiskněte Enter",
    addCondition: "Přidat podmínku",
    sailLevelsHint: "Vyberte úrovně SAIL, pro které autorizace platí",
    uploadPdf: "Nahrát PDF autorizace",
    dropPdfHere: "Přetáhněte PDF sem nebo klikněte",
    pdfUploaded: "PDF nahráno",
    replacePdf: "Nahradit PDF",
    viewPdf: "Zobrazit PDF",
    // Scope fields
    scope: {
      title: "Detaily rozsahu",
      maxHeight: "Max výška AGL (m)",
      maxDistance: "Max vzdálenost (m)",
      airspaceClasses: "Třídy vzdušného prostoru",
      geographicLimitations: "Geografická omezení",
      operationalVolume: "Operační prostor",
      groundRiskClass: "Třída pozemního rizika (GRC)",
      airRiskClass: "Třída vzdušného rizika (ARC)",
      containmentRequirements: "Požadavky na omezení",
      privileges: "Oprávnění",
      maxSailLevel: "Max úroveň SAIL",
      droneClasses: "Třídy dronů",
      omaReference: "Reference OMA",
      description: "Popis",
      limitations: "Omezení",
      comingSoon: "Detaily rozsahu pro tento typ budou brzy k dispozici"
    },
    // Warnings
    noValidAuthorization: "Žádná platná autorizace pro SAIL {level}",
    authorizationExpiresSoon: "Autorizace vyprší za {days} dní",
    authorizationExpired: "Autorizace vypršela",
    authorizationRequired: "Pro schválení mise SAIL {level} je vyžadována operační autorizace",
    sailNotRequired: "SAIL I-II nepožaduje operační autorizaci",
    // Confirmation
    deleteConfirm: "Opravdu chcete smazat tuto autorizaci?",
    deleteWarning: "Tato akce je nevratná.",
    revokeConfirm: "Opravdu chcete zrušit tuto autorizaci?",
    revokeWarning: "Zrušené autorizace nelze použít pro schválení mise.",
    // Success messages
    authorizationCreated: "Autorizace vytvořena",
    authorizationUpdated: "Autorizace aktualizována",
    authorizationDeleted: "Autorizace smazána",
    authorizationRevoked: "Autorizace zrušena",
    authorizationSuspended: "Autorizace pozastavena",
    documentUploaded: "Dokument nahrán",
    loadError: "Nepodařilo se načíst autorizaci",
    saveError: "Nepodařilo se uložit autorizaci",
    scopeChangeConfirm: "Neuložené změny v této autorizaci se ztratí. Opravdu chcete přepnout organizaci?",
    // Filter
    filterByStatus: "Filtrovat podle stavu",
    filterByType: "Filtrovat podle typu",
    filterBySail: "Filtrovat podle SAIL",
    allStatuses: "Všechny stavy",
    allTypes: "Všechny typy",
    allSailLevels: "Všechny úrovně",
    // Widget
    expiringWidget: {
      title: "Autorizace brzy vyprší",
      viewAll: "Zobrazit vše",
      noExpiring: "Žádné autorizace brzy nevyprší",
      daysLeft: "dní zbývá"
    }
  },
  
  // CheckMate - Fast Track & LUC (Sprint E4)
  checkmate: {
    fastTrack: {
      sectionTitle: "Doporučená cesta",
      sectionSubtitle: "Rychlejší cesty ke shodě pomocí vašich oprávnění",
      appliesBadge: "Splňuje",
      verifyBadge: "Ověřte rozsah",
      expiredBadge: "Vypršela",
      expiringSoonBadge: "Vyprší za {days} dnů",
      timeSaved: "Ušetří {days} dnů",
      timeSavedShort: "{days}d úspora",
      useThisPath: "Použít tuto cestu",
      verifyAndAuthorize: "Ověřit a autorizovat",
      referenceNumber: "Č.: {ref}",
      validUntil: "Platnost do {date}",
      alreadyApplied: "Fast track již aplikován",
      appliedBy: "Aplikováno uživatelem {email} dne {date}",
      noFastTracks: "Pro tuto misi nejsou k dispozici žádné fast tracky",
      
      subtypes: {
        STS_DECLARATION: "Deklarace STS",
        PDRA_REGISTRATION: "Registrace PDRA",
        LUC_SELF_AUTHORIZE: "LUC samoautorizace",
        OPERATIONAL_AUTH_USE: "Operační autorizace",
      },
      
      successToast: "Fast track byl úspěšně aplikován",
      errorToast: "Aplikace fast tracku selhala",
    },
    
    standardMitigations: {
      sectionTitle: "Standardní opatření",
      sectionSubtitle: "Alternativní cesty přes M1/M2 opatření",
    },
    
    lucVerification: {
      title: "Ověření rozsahu LUC",
      subtitle: "Ověřte, že váš LUC pokrývá tuto misi",
      provides: "Váš LUC poskytuje:",
      requires: "Tato mise vyžaduje:",
      appearsToCover: "Váš LUC zřejmě pokrývá tuto misi.",
      confirmCheckbox: "Potvrzuji, že jsem ověřil(a) rozsah LUC odpovídá této misi a přijímám odpovědnost za soulad.",
      selfAuthorizeBtn: "Samoautorizovat misi",
      cancelBtn: "Zrušit",
      
      fields: {
        maxSailLevel: "Max úroveň SAIL",
        droneClasses: "Pokryté třídy dronů",
        privileges: "Oprávnění",
        missionSail: "SAIL mise",
        missionDroneClass: "Třída dronu mise",
      },
    },
    
    expiringSoon: {
      bannerTitle: "Oprávnění brzy vyprší",
      item: "{type} ({ref}) — vyprší za {days} dnů",
      renewLink: "Obnovit",
    },
    
    expired: {
      bannerTitle: "Vypršelá oprávnění",
      item: "{type} ({ref}) — vypršela {date}",
    },
    
    // WAVE 2A: Flight Mode translations
    flightMode: {
      sectionTitle: "Režim letu",
      sectionSubtitle: "Vyberte typ operace",
      vlos: "VLOS",
      vlosDescription: "Visual Line of Sight — přímý vizuální kontakt s dronem",
      evlos: "EVLOS",
      evlosDescription: "Extended VLOS — s řetězcem pozorovatelů",
      bvlos: "BVLOS",
      bvlosDescription: "Beyond VLOS — mimo přímou viditelnost",
      impactNote: "Režim letu ovlivňuje kategorii operace",
      openEligible: "Způsobilý pro Open kategorii",
      specificRequired: "Vyžaduje Specific kategorii",
    },
    
    // WAVE 2A: Containment translations
    containment: {
      sectionTitle: "Konfigurace omezení",
      sectionSubtitle: "Nastavení bezpečnostních systémů pro tuto misi",
      geoFence: "Geo-fence",
      geoFenceEnabled: "Aktivní",
      geoFenceDisabled: "Neaktivní",
      geoFenceNotApplicable: "Není k dispozici",
      returnToHome: "Return-to-Home",
      rthAutomatic: "Automatický",
      rthManual: "Manuální",
      rthNone: "Žádný",
      fts: "Systém ukončení letu (FTS)",
      ftsParachute: "Padák",
      ftsKinetic: "Kinetické ukončení",
      ftsNone: "Žádný",
      observer: "Dedikovaný pozorovatel",
      kineticEnergyLimit: "Limit kinetické energie (J)",
      containmentLevel: "Úroveň omezení",
      levelRobust: "Robustní",
      levelStandard: "Standardní",
      levelMinimal: "Minimální",
      sailImpact: "Dopad na SAIL",
      fromAircraftProfile: "Z profilu dronu",
      operatorOverride: "Přepsáno operátorem",
      aircraftLacksEquipment: "Tento dron nemá tuto výbavu",
    },
  },
  
  // Organizations page
  organizations: {
    title: "Organizace",
    subtitle: "Správa provozovatelů dronů",
    searchPlaceholder: "Hledat organizace...",
    addButton: "Přidat organizaci",
    columns: {
      companyName: "Název společnosti",
      type: "Typ",
      category: "Kategorie",
      subscription: "Předplatné",
      authorization: "Autorizace",
      responsiblePerson: "Odpovědná osoba",
      compliance: "Shoda",
    },
    badges: {
      specific: "Specifická",
      industrial: "Průmyslová",
      enterprise: "Enterprise",
      open: "Open",
      free: "Zdarma",
      professional: "Professional",
    },
    emptyState: "Žádné organizace nenalezeny",
    errorLoading: "Nepodařilo se načíst organizace",
    updated: "Organizace úspěšně aktualizována",
    created: "Organizace úspěšně vytvořena",
    saveError: "Nepodařilo se uložit organizaci",
    deleted: "Organizace smazána",
    deleteError: "Nepodařilo se smazat organizaci",
    subscriptionUpdated: "Předplatné aktualizováno na {tier}",
    subscriptionUpdateError: "Nepodařilo se aktualizovat předplatné",
  },
  
  // Users page
  users: {
    title: "Uživatelé",
    subtitle: "Všichni uživatelé platformy",
    orgMembers: "Členové organizace",
    searchPlaceholder: "Hledat uživatele...",
    platformLevel: "Úroveň platformy",
    adminOnly: "Uživatele mohou zobrazit jen administrátoři",
    columns: {
      user: "Uživatel",
      email: "E-mail",
      role: "Role",
      organization: "Organizace",
      status: "Stav",
    },
    emptyState: "Žádní uživatelé nenalezeni",
    errorLoading: "Nepodařilo se načíst uživatele",
    statuses: {
      active: "Aktivní",
      inactive: "Neaktivní",
      pending: "Čeká na ověření",
    },
    fields: {
      name: "Jméno",
      newPassword: "Nové heslo",
    },
    actions: {
      createUser: "Nový uživatel",
      resetPassword: "Resetovat heslo",
      deactivate: "Deaktivovat",
      reactivate: "Reaktivovat",
      deleteUser: "Smazat",
    },
    confirm: {
      deleteUser: "Tato akce účet uživatele TRVALE a NEVRATNĚ smaže. Nelze vzít zpět. Pokračovat?",
    },
    dialogs: {
      createTitle: "Vytvořit uživatele",
      editTitle: "Upravit uživatele",
      resetPasswordTitle: "Reset hesla",
    },
    validation: {
      nameRequired: "Jméno je povinné.",
      emailRequired: "E-mail je povinný.",
      emailInvalid: "Zadejte platnou e-mailovou adresu.",
      passwordLength: "Heslo musí mít 6 až 20 znaků.",
      organizationRequired: "Pro tuto roli je nutné vybrat organizaci.",
      demotionOrganizationRequired: "Při změně role platform administrátora je nutné vybrat organizaci, do které účet přejde.",
    },
    messages: {
      created: "Uživatel vytvořen",
      updated: "Uživatel upraven",
      deactivated: "Uživatel deaktivován",
      reactivated: "Uživatel reaktivován",
      deleted: "Uživatel smazán",
      passwordReset: "Heslo bylo resetováno",
    },
    selfActionHint: "Vlastní roli ani stav si nemůžete změnit.",
    demotionOrgHint: "Platform administrátor nemá organizaci — vyberte tu, do které účet přejde.",
    promotionOrgNotice: "Platform administrátor nemá organizaci — účet bude ze své stávající organizace odebrán.",
    createOrgLockedHint: "Noví uživatelé se zakládají do aktivní organizace. Pro jinou organizaci ji nejprve přepněte v hlavičce.",
  },
  
  // Bulletins page
  bulletins: {
    title: "Compliance bulletiny",
    subtitle: "Vytvářejte a spravujte regulatorní bulletiny",
    tabs: {
      all: "Vše",
      drafts: "Koncepty",
      sent: "Odeslané",
    },
    columns: {
      title: "Název",
      type: "Typ",
      severity: "Závažnost",
      status: "Stav",
      effective: "Platnost od",
      recipients: "Příjemci",
      actions: "Akce",
    },
    badges: {
      systemInfo: "Systémová informace",
      regulatoryChange: "Regulatorní změna",
      informational: "Informativní",
      critical: "Kritické",
      important: "Důležité",
      sent: "Odesláno",
      draft: "Koncept",
      all: "Vše",
    },
    newBulletin: "Nový bulletin",
    attributionBy: "od",
    errorLoading: "Nepodařilo se načíst bulletiny",
    selectOrgRequired: "Vyberte alespoň jednu organizaci",
    titleRequired: "Název je povinný",
    contentRequired: "Obsah je povinný",
    updated: "Bulletin aktualizován",
    created: "Bulletin vytvořen",
    saveError: "Nepodařilo se uložit bulletin",
    selectKbDocFirst: "Nejprve vyberte dokument znalostní báze",
    aiGenerated: "Obsah vygenerován AI - zkontrolujte a upravte podle potřeby",
    aiGenerateError: "Generování AI selhalo",
    deleted: "Bulletin smazán",
    deleteError: "Smazání selhalo",
    sent: "Bulletin odeslán všem příjemcům",
    sendError: "Odeslání selhalo",
  },
  
  // News & Regulations page
  news: {
    title: "Novinky a předpisy",
    subtitle: "Zůstaňte informováni o regulatorních změnách",
    tabs: {
      all: "Vše",
      regulatory: "Regulatorní",
      templates: "Šablony",
      system: "Systémové",
    },
    severities: {
      allSeverities: "Všechny závažnosti",
      informational: "Informativní",
      critical: "Kritické",
      important: "Důležité",
      systemInfo: "Systémová informace",
      regulatoryChange: "Regulatorní změna",
    },
    labels: {
      effective: "Platnost od",
      readLink: "Číst",
    },
    errorLoading: "Nepodařilo se načíst novinky",
  },
  
  // Centralized error messages
  errors: {
    failedToLoadPilots: "Nepodařilo se načíst piloty",
    failedToLoadAircraft: "Nepodařilo se načíst drony",
    failedToLoadAuthorizations: "Nepodařilo se načíst autorizace",
    failedToLoadInsurance: "Nepodařilo se načíst pojistné smlouvy",
    failedToLoadUsers: "Nepodařilo se načíst uživatele",
    failedToLoadOrganizations: "Nepodařilo se načíst organizace",
    failedToLoadMissions: "Nepodařilo se načíst mise",
    failedToLoadBulletins: "Nepodařilo se načíst bulletiny",
    failedToLoadNews: "Nepodařilo se načíst novinky",
    failedToCreate: "Nepodařilo se vytvořit",
    failedToUpdate: "Nepodařilo se aktualizovat",
    failedToDelete: "Nepodařilo se smazat",
    resetPasswordFailed: "Nepodařilo se resetovat heslo",
    networkError: "Chyba sítě",
    unauthorized: "Neoprávněný přístup",
    forbidden: "Přístup zamítnut",
    serverError: "Chyba serveru",
    // Quota errors (Sprint H1.5.2)
    quota: {
      orgQuotaExceeded: "Organizace překročila hodinový limit požadavků pro váš tarif. Zkuste to později nebo upgradujte.",
      concurrentAiLimit: "Dosažen souběžný limit AI požadavků. Zkuste to za chvíli.",
      rateLimitExceeded: "Překročen limit požadavků. Zkuste to později.",
      upgradeRequired: "Pro tuto funkci je nutný vyšší tarif.",
      limitReached: "Dosažen limit",
      tryAgainLater: "Zkuste to později",
      upgradeNow: "Upgradujte nyní",
    },
    // AI Quota errors (Sprint H1.5.3)
    aiQuota: {
      exhausted: "Měsíční limit AI volání vyčerpán. Upgradujte tarif nebo doplňte kredit.",
      approachingLimit: "Blížíte se k měsíčnímu limitu AI volání.",
      usagePercent: "Využito {percent}% měsíčního limitu AI.",
      callsRemaining: "Zbývá {remaining} AI volání tento měsíc.",
      resetAt: "Limit se obnoví {date}.",
      upgradeOrTopup: "Upgradujte tarif nebo doplňte kredit.",
    },
    // Resource Quota errors (Sprint H1.5.4)
    resourceQuota: {
      exceeded: "Limit prostředku pro váš tarif vyčerpán.",
      missions: "Měsíční limit misí pro váš tarif vyčerpán.",
      pilots: "Limit pilotů pro váš tarif vyčerpán.",
      documents: "Limit dokumentů pro váš tarif vyčerpán.",
      storage: "Limit úložiště pro váš tarif vyčerpán.",
      fileTooLarge: "Soubor je příliš velký. Maximální velikost je 50 MB.",
      upgradeRequired: "Pro vytvoření dalších záznamů upgradujte tarif.",
      current: "Aktuální: {current}",
      limit: "Limit: {limit}",
    },
    // Server errors (Sprint H1.5.4)
    server: {
      requestTimeout: "Požadavek trval příliš dlouho.",
      gatewayTimeout: "Server neodpověděl včas.",
    },
  },
  
  // Admin Usage Dashboard (Sprint H1.5.5)
  adminUsage: {
    title: "Přehled využití platformy",
    subtitle: "Sledování využití organizací a správa limitů prostředků",
    totalOrgs: "Celkem organizací",
    highUsage: "Vysoké využití (>80%)",
    anomalies: "Anomálie",
    unlimitedTier: "Neomezený tarif",
    organization: "Organizace",
    tier: "Tarif",
    missions: "Mise",
    pilots: "Piloti",
    documents: "Dokumenty",
    storage: "Úložiště",
    apiCalls: "API volání",
    aiCalls: "AI volání",
    lastActivity: "Poslední aktivita",
    actions: "Akce",
    allTiers: "Všechny tarify",
    searchOrgs: "Hledat organizace...",
    sortHighestUsage: "Nejvyšší využití",
    sortApiCalls: "API volání",
    sortAiCalls: "AI volání",
    sortStorage: "Úložiště",
    noOrgsFound: "Žádné organizace nenalezeny",
    resourceUsage: "Využití prostředků",
    apiUsage: "Využití API",
    used: "Využito",
    limit: "Limit",
    createOverride: "Vytvořit výjimku",
    resource: "Prostředek",
    newLimit: "Nový limit",
    reason: "Důvod",
    reasonPlaceholder: "Zákazník požádal o dočasné navýšení pro projekt X",
    expiresAt: "Platnost do",
    saveOverride: "Uložit výjimku",
    overrideCreated: "Výjimka úspěšně vytvořena",
    overrideValidation: "Vyplňte všechna pole. Důvod musí mít alespoň 10 znaků.",
    anomalyAlerts: "Upozornění na anomálie",
    accessDenied: "Přístup odepřen",
    platformAdminOnly: "Tato stránka je přístupná pouze správcům platformy.",
  },

  // Admin Feature Flags (Sprint H2.4)
  adminFeatures: {
    title: "Příznaky funkcí",
    subtitle: "Správa funkcí pro jednotlivé organizace",
    organization: "Organizace",
    tier: "Tarif",
    defaultFeatures: "Výchozí funkce",
    explicitlyEnabled: "Explicitně povolené",
    effectiveFeatures: "Efektivní funkce",
    availableFeatures: "Dostupné funkce",
    auditLog: "Historie změn",
    enable: "Povolit",
    disable: "Zakázat",
    enabled: "Povoleno",
    disabled: "Zakázáno",
    defaultForTier: "Výchozí pro tento tarif",
    cannotDisableDefault: "Nelze zakázat výchozí funkce",
    enableFeature: "Povolit funkci",
    disableFeature: "Zakázat funkci",
    reason: "Důvod",
    reasonPlaceholder: "Vysvětlete důvod této změny (min. 10 znaků)...",
    reasonTooShort: "Důvod musí mít alespoň 10 znaků",
    confirmEnable: "Potvrdit povolení",
    confirmDisable: "Potvrdit zakázání",
    featureEnabled: "Funkce úspěšně povolena",
    featureDisabled: "Funkce úspěšně zakázána",
    noAuditEntries: "Zatím žádné záznamy",
    auditAction: "Akce",
    auditAdmin: "Správce",
    auditReason: "Důvod",
    auditTimestamp: "Čas",
    loading: "Načítání...",
    error: "Chyba při načítání funkcí",
    accessDenied: "Přístup odepřen",
    platformAdminOnly: "Správu příznaků funkcí mohou provádět pouze správci platformy.",
    backToOrgs: "Zpět na organizace",
  },

  // Geometry Import - Phase X1
  // Mission take-off point + flight area (mission-map unification, PR6)
  flightArea: {
    sectionTitle: "Místo vzletu a oblast letu",
    sectionHelper: "Nejprve umístěte místo vzletu, pak nakreslete oblast letu (polygon, trasu s koridorem nebo kružnici).",
    takeoffPoint: "Místo vzletu",
    setTakeoff: "Umístit místo vzletu",
    setTakeoffActive: "Klikněte do mapy…",
    takeoffHelper: "Klikněte do mapy, přetáhněte značku nebo vyhledejte adresu",
    takeoffRequired: "Zadejte místo vzletu",
    latitude: "Zeměpisná šířka",
    longitude: "Zeměpisná délka",
    searchPlaceholder: "Hledat adresu nebo místo…",
    search: "Najít",
    searchNotFound: "Místo nebylo nalezeno",
    searchFailed: "Vyhledávání selhalo",
    area: "Oblast letu",
    drawPolygon: "Nakreslit oblast (polygon)",
    drawLine: "Nakreslit trasu (linie s koridorem)",
    drawHint: "Oblast nakreslete nástroji vlevo nahoře na mapě.",
    replaceConfirm: "Nahradit stávající oblast letu?",
    editVertices: "Upravit vrcholy",
    deleteArea: "Smazat oblast",
    deleteConfirm: "Smazat oblast letu? Bez ní misi nepůjde uložit.",
    areaRequired: "Nakreslete oblast letu",
    typePolygon: "Polygon (oblast)",
    typeLine: "Linie (trasa s koridorem)",
    typeCircle: "Kružnice",
    geometryType: "Typ oblasti",
    vertexCount: "Počet vrcholů",
    length: "Délka trasy",
    perimeter: "Obvod",
    areaSize: "Plocha",
    corridorArea: "Plocha koridoru",
    corridorWidth: "Šířka koridoru (m)",
    corridorWidthHelper: "Celková šířka, polovina na každou stranu od osy ({min}–{max} m)",
    corridorApply: "Použít",
    corridorWidthAction: "Šířka koridoru",
    corridorWidthActionTitle: "Nastavit šířku koridoru trasy",
    corridorWidthRequired: "Zadejte šířku koridoru",
    corridorWidthRange: "Šířka koridoru musí být {min}–{max} m",
    circleRadius: "Poloměr kružnice (m)",
    circleRadiusHelper: "Poloměr od středu kružnice ({min}–{max} m)",
    circleRadiusAction: "Poloměr",
    circleRadiusActionTitle: "Nastavit poloměr kružnice",
    circleRadiusRequired: "Zadejte poloměr kružnice",
    circleRadiusRange: "Poloměr musí být v rozsahu {min}–{max} m.",
    circleRadiusFixBeforeSave: "Opravte poloměr, nebo úpravu zrušte.",
    circleCenter: "Střed kružnice",
    takeoffAtCircleCenter: "Vzlet ve středu kružnice",
    coordinates: "Souřadnice vrcholů",
    showCoordinates: "Zobrazit souřadnice",
    hideCoordinates: "Skrýt souřadnice",
    vertex: "Vrchol",
    takeoffInside: "Místo vzletu leží v oblasti letu",
    takeoffNear: "Místo vzletu je {distance} od oblasti letu",
    takeoffWarning: "Místo vzletu je {distance} od oblasti letu (víc než {limit}) — zkontrolujte jeho polohu",
    takeoffTooFar: "Místo vzletu je příliš daleko od oblasti letu ({distance}, max. {max})",
    validating: "Kontroluji oblast…",
    validationUnavailable: "Oblast se nepodařilo zkontrolovat — o platnosti rozhodne uložení.",
    importFromFile: "Importovat ze souboru",
    importAfterSave: "Import ze souboru bude dostupný po uložení mise",
    importSingleOnly: "Soubor obsahuje {count} prvků. Zatím lze použít jen soubor s jedním polygonem nebo jednou linií.",
    importHoles: "Polygon s otvory není podporován",
    importPoints: "Soubor obsahuje jen body — oblast z nich zatím nelze vytvořit",
    importUnsupported: "Tento typ geometrie nelze použít jako oblast letu (jen polygon nebo linie)",
    importEmpty: "Soubor neobsahuje žádnou geometrii",
    importApplied: "Geometrie převzata do formuláře — uloží se s misí",
    useGeometry: "Použít geometrii",
    legacyNoArea: "Mise nemá oblast letu. Doplňte ji v úpravě mise — bez ní misi nepůjde uložit ani schválit.",
    legacyInvalidArea: "Uložená oblast letu není platná ({reason}). Nakreslete ji znovu.",
    legacyNoTakeoff: "Mise nemá místo vzletu. Doplňte ho v úpravě mise.",
    legacyNoWidth: "Trasa nemá šířku koridoru. Doplňte ji v úpravě mise.",
    legacyNoRadius: "Kružnice nemá poloměr. Doplňte ho v úpravě mise.",
    reasonHoles: "polygon s otvory",
    reasonPoints: "jen body",
    reasonUnsupported: "nepodporovaný typ geometrie",
    reasonMalformed: "poškozená geometrie",
    lockedCompleted: "Mise je dokončená — oblast ani místo vzletu nelze měnit.",
    takeoffAddress: "Adresa místa vzletu",
    editMission: "Upravit misi",
    legendTitle: "Vrstvy mapy",
    legendTakeoff: "Místo vzletu",
    legendArea: "Oblast letu",
    legendCircle: "Oblast letu (kružnice)",
    legendRoute: "Trasa",
    legendCorridor: "Koridor",
    airports: "Letiště",
    missingForSave: "Pro uložení chybí: {items}",
    invalidForSave: "Nelze uložit — {items}",
    finishMapSession: "Dokončete nebo zrušte úpravu oblasti na mapě (tlačítka u nástrojů mapy vlevo nahoře).",
    takeoffTooFarUnmeasured: "Místo vzletu je příliš daleko od oblasti letu.",
  },

  uasZones: {
    title: "UAS zóny (ŘLP)",
    themes: {
      aviation: "Letectví",
      defence: "Obrana státu",
      nature: "Ochrana přírody",
      infrastructure: "Infrastruktura",
      population: "Hustě osídlený prostor",
    },
    zoomInFor: "Přibližte mapu pro:",
    tooMany: "V tomto výřezu je příliš mnoho zón — přibližte mapu nebo vypněte některé vrstvy.",
    error: "Zóny se nepodařilo načíst.",
    noData: "Data zón nejsou naimportovaná.",
    source: "Zdroj: ŘLP ČR",
    dataAsOf: "data k",
    disclaimer: "Informativní zobrazení — závazné hranice ověřte v DroneMap.",
    popupHeight: "Výška zóny",
    popupMaxHeight: "Max. povolená výška",
    popupDataAsOf: "Data ŘLP k",
    attribution: "Zeměpisné zóny UAS © ŘLP ČR",
  },
  geometryImport: {
    title: "Import geometrie",
    subtitle: "Import letové zóny z KML, GeoJSON, GPX nebo CSV",
    importButton: "Importovat geometrii",
    dropHere: "Přetáhněte soubor sem...",
    dragDrop: "Přetáhněte soubor sem nebo klikněte pro výběr",
    supportedFormats: "Podporované formáty: KML, KMZ, GeoJSON, GPX, CSV",
    formatHint: "Formát",
    autoDetect: "Automatická detekce",
    gpxPrefer: "GPX preference",
    waypoints: "Waypointy",
    track: "Trasa",
    latColumn: "Sloupec zeměpisné šířky",
    lonColumn: "Sloupec zeměpisné délky",
    loadPreview: "Načíst náhled",
    previewLoaded: "Náhled načten",
    previewFailed: "Nepodařilo se načíst náhled",
    features: "Prvky",
    points: "Body",
    validGeometry: "Platná geometrie",
    invalidGeometry: "Neplatná geometrie",
    simplify: "Zjednodušit geometrii",
    reduced: "Zredukováno",
    suggestions: "Návrhy",
    cancel: "Zrušit",
    import: "Importovat geometrii",
    importSuccess: "Geometrie úspěšně importována",
    commitFailed: "Nepodařilo se uložit geometrii",
    fileTooLarge: "Soubor je příliš velký",
    unsupportedFormat: "Nepodporovaný formát souboru",
    noFileSelected: "Nebyl vybrán žádný soubor",
    // SAIL change notifications
    sailChanged: "SAIL se změnil",
    sailChangedFrom: "Úroveň SAIL se změnila z",
    sailChangedTo: "na",
    checkmateNeedsReview: "Geometrie se změnila — doporučujeme znovu projít CheckMate",
    rerunCheckmate: "Znovu spustit CheckMate",
  },

  // Aircraft Calendar - Phase X2
  aircraft: {
    calendar: {
      title: "Letový plán",
      subtitle: "Přehled plánovaných misí pro vaše drony",
      perDrone: "Jeden dron",
      fleet: "Flotila",
      selectDrone: "Vyberte dron:",
      noMissions: "Žádné mise v tomto období",
      noDrones: "Žádné drony",
      missions: "misí",
      drones: "dronů",
      day: "Den",
      week: "Týden", 
      month: "Měsíc",
      today: "Dnes",
      previous: "Předchozí",
      next: "Další",
      fleetOverview: "Přehled flotily",
      drone: "Dron",
      status: "Stav",
      telemetry: "Telemetrie",
      draft: "Koncept",
      ready: "Připraveno",
      active: "Probíhá",
      completed: "Dokončeno",
      live: "Živě",
      offline: "Offline",
      noData: "Bez dat",
      mission: "Mise",
      pilot: "Pilot",
      time: "Čas",
      sail: "SAIL",
      tierLimitError: "Bezplatný tarif podporuje max 30denní rozsah. Pro delší rozsah upgradujte tarif.",
      upgradePlan: "Upgradovat tarif",
      dateRange: "Zobrazeno období:",
      clickToCreate: "Klikněte pro vytvoření mise",
      show24h: "Zobrazit celých 24h",
      show16h: "Zobrazit 06-22h",
      timeTooltip: "Čas"
    },
    maintenance: {
      title: "Servis",
      subtitle: "Plánování a historie údržby dronu",
      scheduleNew: "Naplánovat servis",
      noMaintenance: "Zatím nejsou naplánovány žádné servisní intervaly.",
      scheduleFirst: "Naplánujte první servis",
      upcoming: "Nadcházející",
      inProgress: "Probíhající",
      completed: "Dokončené",
      cancelled: "Zrušené",
      history: "Historie servisu",
      currentlyInMaintenance: "Dron je aktuálně v servisu",
      // Scheduler modal
      scheduler: {
        createTitle: "Naplánovat údržbu",
        editTitle: "Upravit údržbu",
        startAt: "Začátek",
        endAt: "Konec",
        type: "Typ údržby",
        reason: "Důvod",
        reasonPlaceholder: "Popište důvod údržby (min. 5 znaků)",
        technician: "Technik / Servisní firma",
        technicianPlaceholder: "Nepovinné",
        notes: "Poznámky",
        notesPlaceholder: "Další poznámky k údržbě",
        submit: "Uložit",
        cancel: "Zrušit",
        cancelMaintenance: "Zrušit údržbu",
        cancelReason: "Důvod zrušení",
        confirmCancel: "Opravdu chcete zrušit tuto údržbu?",
        forceSchedule: "Přesto naplánovat"
      },
      // Types
      types: {
        scheduled: "Plánovaný",
        unscheduled: "Mimořádný",
        calibration: "Kalibrace",
        repair: "Oprava",
        inspection: "Revize"
      },
      // Statuses
      statuses: {
        scheduled: "Naplánováno",
        in_progress: "Probíhá",
        completed: "Dokončeno",
        cancelled: "Zrušeno"
      },
      // Conflicts
      conflicts: {
        title: "Konflikt s misemi",
        message: "Tato údržba koliduje s následujícími misemi:",
        forceCreate: "Přesto vytvořit údržbu",
        cancelCreation: "Zrušit",
        missionWarning: "Vybraný dron je v servisu v tomto období. Změňte čas mise nebo vyberte jiného drona."
      },
      // Table headers
      dateRange: "Období",
      typeHeader: "Typ",
      statusHeader: "Stav",
      reasonHeader: "Důvod",
      technicianHeader: "Technik",
      actions: "Akce",
      edit: "Upravit",
      view: "Zobrazit",
      detail: {
        info: "Informace",
        serialNumber: "Sériové číslo",
        registration: "Registrace",
        flightHours: "Letové hodiny",
        lastMaintenance: "Poslední údržba",
        serviceInterval: "Interval servisu"
      }
    }
  },
  mission: {
    maintenance_conflict: {
      warning: "Vybraný dron je v servisu v tomto období.",
      change_time: "Změňte čas mise nebo vyberte jiného drona."
    }
  },
  // Wave 2B: Radio Telephony
  radioTelephony: {
    title: "Radiotelefonní licence",
    addLicense: "Přidat RT licenci",
    editLicense: "Upravit RT licenci",
    licenseType: "Typ licence",
    licenseNumber: "Číslo licence",
    issuer: "Vydávající úřad",
    issuedAt: "Datum vydání",
    expiresAt: "Datum expirace",
    languages: "Jazyky",
    languagesHint: "Vyberte jazyky, pro které je RT licence platná",
    notes: "Poznámky",
    notesPlaceholder: "Volitelné poznámky...",
    licenseNumberRequired: "Číslo licence je povinné",
    issueDateRequired: "Datum vydání je povinné",
    expiryDateRequired: "Datum expirace je povinné",
    languageRequired: "Alespoň jeden jazyk je povinný",
    licenseAdded: "RT licence přidána",
    licenseUpdated: "RT licence aktualizována",
    licenseDeleted: "RT licence smazána",
    saveFailed: "Nepodařilo se uložit licenci",
    deleteFailed: "Nepodařilo se smazat licenci",
    confirmDelete: "Opravdu chcete smazat tuto RT licenci?",
    other: "Jiný",
    // Status badges
    status: {
      valid: "Platná",
      expiringSoon: "Brzy vyprší",
      expired: "Vypršela",
      none: "Žádná"
    },
    // Mission validation
    missionWarning: "Mise v řízeném prostoru (CTR/ATZ) vyžaduje platnou radiotelefonní licenci pilota.",
    missionBlocked: "Pilot nemá platnou RT licenci pro provoz v řízeném vzdušném prostoru.",
    noLicenses: "Zatím žádné RT licence",
    hint: "Vyžadováno pro operace v řízeném vzdušném prostoru (CTR/ATZ)"
  },
  // Wave 2B: Remote ID
  remoteId: {
    title: "Remote ID konfigurace",
    ridType: "Typ Remote ID",
    ridSerial: "Sériové číslo RID modulu",
    ridSerialHint: "Volitelné: Sériové číslo RID modulu pro sledovatelnost",
    exemptionId: "ID výjimky",
    exemptionIdHint: "Oficiální číslo výjimky od národního CAA",
    exemptionExpires: "Platnost výjimky do",
    exemptionIdRequired: "ID výjimky je povinné při statusu 'Výjimka'",
    ridUpdated: "Remote ID konfigurace aktualizována",
    saveFailed: "Nepodařilo se uložit RID konfiguraci",
    // Types
    builtIn: "Vestavěný (továrně integrovaný)",
    addOn: "Přídavný modul",
    modular: "Modulární (externí)",
    broadcastOnly: "Pouze vysílání",
    exempted: "Výjimka (s dokumentací)",
    none: "Žádný / Nevybaveno",
    // Status
    compliantStatus: "RID vyhovující",
    nonCompliantStatus: "RID nevyhovující",
    exemptedStatus: "S výjimkou (vyžaduje dokumentaci)",
    compliantHint: "Tento dron může být použit pro operace v EU vyžadující RID.",
    nonCompliantHint: "Tento dron nelze použít pro operace vyžadující RID.",
    exemptedHint: "Zadejte níže ID výjimky.",
    euRegInfo: "Nařízení EU 2019/947 vyžaduje Remote ID pro většinu dronových operací v EU od roku 2024. Drony bez vyhovujícího RID nelze přiřadit k misím v regulovaném prostoru.",
    // Mission validation
    missionWarning: "Mise vyžaduje dron s Remote ID. Vybraný dron není RID compliant.",
    missionBlocked: "Dron není Remote ID compliant a nemůže být použit pro tuto misi."
  },
  
  // Wave 2.5 Block D: Map Settings
  mapSettings: {
    title: "Mapové podklady",
    description: "Nastavení mapových služeb třetích stran",
    mapyCzTitle: "Mapy.cz API klíč",
    mapyCzDescription: "Pro používání Mapy.cz jako podkladové mapy potřebujete API klíč.",
    currentKey: "Aktuální klíč",
    noKeyConfigured: "Žádný klíč není nastaven",
    newKey: "Nový API klíč",
    placeholder: "Vložte váš Mapy.cz API klíč",
    save: "Uložit",
    saving: "Ukládám...",
    testKey: "Otestovat klíč",
    testing: "Testuji...",
    testSuccess: "Formát klíče je validní",
    testFailed: "Neplatný formát klíče",
    saved: "Nastavení uloženo",
    error: "Chyba při ukládání",
    warning: "Mapy.cz free tier: 5000 dlaždic/den. Pro intenzivní provoz doporučujeme placený tier.",
    getKeyLink: "Získat API klíč",
    noPermission: "Nemáte oprávnění upravovat nastavení mapy"
  },
  
  // Wave 2.5 Block D: Map Layers
  mapLayers: {
    title: "Vrstvy",
    baseMaps: "Podkladové mapy",
    overlays: "Překryvné vrstvy",
    missionPolygon: "Oblast mise",
    airspaces: "Vzdušné prostory",
    densityHeatmap: "Hustota populace",
    settlements: "Sídla",
    landuse: "Využití půdy",
    requiresApiKey: "Vyžaduje Mapy.cz API klíč v nastavení organizace",
    // Density legend
    densityTitle: "Hustota populace",
    sparse: "Řídká (<5/km²)",
    low: "Nízká (5-50/km²)",
    medium: "Střední (50-500/km²)",
    high: "Vysoká (>500/km²)",
    // Land use legend
    landuseTitle: "Využití půdy",
    residential: "Obytná",
    commercial: "Komerční",
    industrial: "Průmyslová",
    agricultural: "Zemědělská",
    forest: "Les",
    water: "Vodní plocha",
    // Popup labels
    population: "Obyvatel",
    density: "Hustota",
    source: "Zdroj",
    type: "Typ"
  },
  
  // Wave 3 Block 3B: Battery Management Extended
  battery: {
    title: "Baterie",
    addBattery: "Přidat baterii",
    editBattery: "Upravit baterii",
    serialNumber: "Sériové číslo",
    modelName: "Model baterie",
    manufacturer: "Výrobce",
    capacityWh: "Kapacita (Wh)",
    chemistry: "Chemie",
    chemistryLiPo: "Li-Po (Lithium Polymer)",
    chemistryLiHV: "Li-HV (High Voltage)",
    chemistryLiIon: "Li-Ion",
    chemistryOther: "Jiná",
    cycleCount: "Počet cyklů",
    cycleLimit: "Limit cyklů",
    status: "Stav",
    statusActive: "Aktivní",
    statusRetired: "Vyřazeno",
    statusMaintenance: "V údržbě",
    manufacturedDate: "Datum výroby",
    purchasedDate: "Datum nákupu",
    retirementDate: "Datum vyřazení",
    retirementReason: "Důvod vyřazení",
    compatibleAircraft: "Kompatibilní drony",
    notes: "Poznámky",
    qrCode: "QR kód",
    printLabels: "Tisknout štítky",
    downloadLabels: "Stáhnout štítky (PDF)",
    noBatteriesToPrint: "Žádné baterie k tisku",
    bulkImport: "Hromadný import",
    importTemplate: "Šablona importu",
    retire: "Vyřadit",
    retireConfirm: "Opravdu chcete vyřadit tuto baterii?",
    retireReasonRequired: "Zadejte důvod vyřazení",
    incrementCycle: "Přidat cyklus",
    cycleIncremented: "Cyklus přidán",
    batteryRetired: "Baterie vyřazena",
    duplicateSerial: "Baterie s tímto sériovým číslem již existuje",
    cannotUpdateRetired: "Nelze upravovat vyřazenou baterii",
    cannotCycleRetired: "Nelze započítat cyklus vyřazené baterie",
    searchPlaceholder: "Hledat podle sériového čísla nebo modelu...",
    filterByStatus: "Filtrovat podle stavu",
    filterByManufacturer: "Filtrovat podle výrobce",
    lastChargedAt: "Poslední nabití",
    currentCharge: "Aktuální nabití",
    cycleProgress: "Stav životnosti",
    warningThreshold: "Blíží se limitu",
    criticalThreshold: "Překročen limit",
    // Bulk import
    importPreview: "Náhled importu",
    validRows: "Platné řádky",
    errorRows: "Chybné řádky",
    downloadTemplate: "Stáhnout šablonu CSV",
    confirmImport: "Potvrdit import",
    importSuccess: "Import dokončen",
    importedCount: "Importováno",
    skippedCount: "Přeskočeno",
  },
  
  // Wave 3 Block 3B: Drone Catalog
  catalog: {
    title: "Katalog dronů",
    adminTitle: "Správa katalogu dronů",
    addEntry: "Přidat do katalogu",
    editEntry: "Upravit položku",
    manufacturer: "Výrobce",
    model: "Model",
    fullName: "Celý název",
    serviceIntervalHours: "Servisní interval (hodiny)",
    serviceIntervalDays: "Servisní interval (dny)",
    batteryCycleWarning: "Varování cyklu baterií",
    batteryCycleReplacement: "Výměna baterie (cykly)",
    propellerReplacementHours: "Výměna vrtulí (hodiny)",
    defaultRidType: "Výchozí RID typ",
    ridBuiltIn: "Vestavěný",
    ridModular: "Modulární",
    ridNonCompliant: "Bez RID",
    mtomKg: "MTOM (kg)",
    maxSpeedKmh: "Max. rychlost (km/h)",
    maxWindMs: "Max. vítr (m/s)",
    ingressProtection: "IP ochrana",
    deprecated: "Zastaralé",
    includeDeprecated: "Zobrazit zastaralé",
    fromCatalog: "Z katalogu",
    useFromCatalog: "Použít z katalogu",
    overridden: "Přepsáno",
    catalogDefault: "Výchozí z katalogu",
    selectCatalogEntry: "Vybrat z katalogu",
    customNoMatch: "Vlastní / mimo katalog",
    effectiveIntervals: "Efektivní servisní intervaly",
  },
  
  // Admin Drone Catalog
  admin: {
    droneCatalog: {
      title: "Katalog dronů",
      subtitle: "Správa celosvětového katalogu dronů",
      totalEntries: "Celkem položek",
      activeEntries: "Aktivní",
      deprecatedEntries: "Zastaralé",
      lastUpdated: "Naposledy aktualizováno",
    }
  },

  // Correspondence (Sprint Y Block E)
  correspondence: {
    title: "Korespondence",
    subtitle: "Sledování komunikace s úřady",
    timeline: "Časová osa",
    list: "Seznam",
    filters: "Filtry",
    search: "Hledat v korespondenci...",
    noCorrespondence: "Žádná korespondence",
    noCorrespondenceDesc: "Zatím nebyla zaznamenána žádná komunikace s úřady.",
    
    // Status
    status: {
      pending_review: "Čeká na kontrolu",
      reviewed: "Zkontrolováno",
      linked: "Propojeno",
      archived: "Archivováno",
    },
    
    // Direction
    direction: {
      inbound: "Příchozí",
      outbound: "Odchozí",
    },
    
    // Source categories
    categories: {
      regulator: "Regulátor",
      atc: "ATC",
      operator_authority: "Provozovatel",
      police: "Policie",
      fire: "Hasiči",
      energy: "Energetika",
      insurance: "Pojišťovna",
      other: "Ostatní",
    },
    
    // Card & Timeline
    from: "Od",
    to: "Komu",
    received: "Přijato",
    sent: "Odesláno",
    subject: "Předmět",
    attachments: "Přílohy",
    attachment: "příloha",
    viewDetails: "Zobrazit detail",
    viewEmail: "Zobrazit email",
    
    // HITL - Human in the Loop (CRITICAL)
    proposed: "Navrženo",
    proposedBadge: "navrženo — k ověření",
    confirmed: "Potvrzeno",
    confirmedBadge: "potvrzeno",
    awaitingReview: "Čeká na kontrolu operátora",
    needsReview: "Vyžaduje kontrolu",
    reviewInQueue: "V revizní frontě",
    goToReviewQueue: "Přejít do revizní fronty",
    
    // Extracted data
    extractedData: "Extrahovaná data",
    referenceNumber: "Referenční číslo",
    caseNumber: "Číslo jednací",
    deadline: "Termín",
    actionRequired: "Požadovaná akce",
    priority: "Priorita",
    summary: "Souhrn",
    
    // Links
    linkedTo: "Propojeno s",
    proposedLink: "Navržené propojení",
    confirmedLink: "Potvrzené propojení",
    authorization: "Autorizace",
    mission: "Mise",
    pilot: "Pilot",
    noLinkedEntities: "Žádná propojení",
    
    // Filters
    filterBySource: "Filtrovat podle zdroje",
    filterByStatus: "Filtrovat podle stavu",
    filterByDate: "Filtrovat podle data",
    allSources: "Všechny zdroje",
    allStatuses: "Všechny stavy",
    dateFrom: "Od",
    dateTo: "Do",
    
    // Stats
    total: "Celkem",
    pendingReview: "K ověření",
    overdue: "Po termínu",
    thisWeek: "Tento týden",
    
    // Language A: StatTiles
    statTiles: {
      awaitingReview: "Čeká na kontrolu",
      openCases: "Otevřené případy",
      deadlinesSoon: "Termín do 7 dnů",
    },
    
    // Language A: FilterChips
    filterChips: {
      all: "Vše",
      needsReview: "K ověření",
      confirmed: "Potvrzeno",
      awaitingReply: "Čeká na odpověď",
    },
    
    // Detail panel
    selectItem: "Vyberte položku",
    
    // Modal
    emailDetails: "Detail emailu",
    body: "Obsah",
    metadata: "Metadata",
    messageId: "ID zprávy",
    inReplyTo: "Odpověď na",
    
    // Tab labels (for integration)
    tabTitle: "Korespondence",
    tabDescription: "Historie komunikace s úřady",
    
    // Days
    daysAgo: "před {days} dny",
    today: "dnes",
    yesterday: "včera",
    
    // Block G: Review Queue
    review: {
      title: "Revizní fronta korespondence",
      subtitle: "HITL commit gate - potvrzení regulatorních dat",
      queueTitle: "Fronta ke kontrole",
      queueDescription: "Seřazeno podle spolehlivosti (nejnižší první), pak urgence termínu",
      emptyQueue: "Fronta je prázdná",
      emptyQueueDesc: "Všechna korespondence byla zkontrolována.",
      
      // Stats
      statsPending: "Čeká na kontrolu",
      statsUrgent: "Urgentní (s termínem)",
      statsLowConf: "Nízká spolehlivost",
      statsReviewedToday: "Zkontrolováno dnes",
      
      // HITL
      hitlTitle: "Human-in-the-Loop požadavek",
      hitlDescription: "Každý navržený odkaz musí být potvrzen operátorem před commitnutím do regulatorních záznamů. Žádná automatická cesta.",
      
      // Confidence badges
      highConfidence: "Vysoká",
      mediumConfidence: "Střední",
      lowConfidence: "Nízká",
      
      // Deadline badges
      overdue: "Po termínu",
      dueToday: "Dnes",
      daysLeft: "dní",
      
      // Actions
      confirm: "Potvrdit",
      reject: "Zamítnout",
      reopen: "Znovu otevřít",
      
      // Tabs
      tabEmail: "Email",
      tabExtracted: "Extrahovaná data",
      tabLinks: "Navržené odkazy",
      tabAudit: "Audit log",
      
      // Proposed links
      proposedAuth: "Navržená autorizace",
      proposedMission: "Navržená mise",
      proposedPilot: "Navržený pilot",
      
      // Confirm dialog
      confirmTitle: "Potvrdit korespondenci",
      confirmDescription: "Potvrďte nebo upravte navržené odkazy. Tato akce zapíše regulatorní data.",
      linksSection: "Odkazy na entity",
      authorizationId: "ID autorizace",
      missionId: "ID mise",
      pilotId: "ID pilota",
      caseNumberLabel: "Číslo jednací (pro zápis na autorizaci)",
      caseNumberHint: "Pokud vyplníte a propojíte s autorizací, číslo jednací se zapíše na autorizaci.",
      editOverrides: "Upravit extrahovaná data",
      overrideRefNumber: "Přepsat referenční číslo",
      overrideDeadline: "Přepsat termín",
      overridePriority: "Přepsat prioritu",
      overrideSummaryCs: "Přepsat souhrn (CS)",
      overrideSummaryEn: "Přepsat souhrn (EN)",
      selectPriority: "Vyberte prioritu",
      notes: "Poznámky operátora",
      notesPlaceholder: "Volitelné poznámky k této kontrole...",
      confirmAction: "Potvrdit a zapsat",
      
      // Case number conflict
      caseNumberConflict: "Konflikt čísla jednacího",
      keepExisting: "Ponechat stávající",
      overwrite: "Přepsat",
      
      // Reject dialog
      rejectTitle: "Zamítnout korespondenci",
      rejectDescription: "Zamítnutá korespondence bude archivována. Nic nebude zapsáno do regulatorních záznamů.",
      rejectReason: "Důvod zamítnutí",
      rejectReasonPlaceholder: "Uveďte důvod zamítnutí (povinné)...",
      rejectAction: "Zamítnout",
      minChars: "Min. 5 znaků",
      
      // Reopen dialog
      reopenTitle: "Znovu otevřít korespondenci",
      reopenDescription: "Vrátí položku do fronty ke kontrole. Stávající potvrzené odkazy zůstanou viditelné.",
      reopenReason: "Důvod znovuotevření",
      reopenReasonPlaceholder: "Uveďte důvod znovuotevření...",
      reopenAction: "Znovu otevřít",
      
      // Audit
      loadAudit: "Načíst audit log",
      auditTitle: "Historie změn",
      noAuditEntries: "Žádné záznamy auditu",
      auditOperator: "Operátor",
      auditReason: "Důvod",
      auditChanges: "Změny",
    },
  },
  
  // Fleet Map Phase 1
  fleetMap: {
    title: "Mapa flotily",
    subtitle: "Přehled aktivit letadel v reálném čase",
    
    // Filters
    filterAll: "Vše",
    filterInFlight: "Ve vzduchu",
    filterToday: "Dnes",
    filterMaintenance: "Údržba",
    filterAvailable: "Dostupné",
    
    // Time slider
    timeSlider: "Časová osa",
    now: "Nyní",
    days: "dny",
    
    // Status labels
    inFlight: "Ve vzduchu",
    scheduledToday: "Naplánováno dnes",
    scheduledUpcoming: "Naplánováno",
    maintenance: "Údržba",
    available: "Dostupné",
    retired: "Vyřazeno",
    
    // Side panel
    aircraftDetails: "Detaily letadla",
    serial: "Sériové číslo",
    mtom: "MTOM",
    currentMission: "Aktuální mise",
    upcomingMission: "Nadcházející mise",
    missionName: "Název mise",
    pilot: "Pilot",
    etot: "Plánovaný vzlet",
    eldt: "Plánované přistání",
    viewMission: "Zobrazit misi",
    viewAircraft: "Zobrazit letadlo",
    inMaintenance: "V údržbě",
    endsAt: "Konec",
    type: "Typ",
    
    // Equipment
    equipment: "Vybavení",
    battery: "Baterie",
    rid: "RID modul",
    rtLicense: "RT licence",
    active: "Aktivní",
    inactive: "Neaktivní",
    valid: "Platná",
    expired: "Neplatná",
    notInstalled: "Nenainstalováno",
    
    // Tier cap
    tierCapTitle: "Omezení free verze",
    tierCapDescription: "Zobrazeno {shown} z {total} letadel. Pro zobrazení celé flotily upgradujte.",
    upgrade: "Upgradovat",
  },

  // Block D: Aircraft Detail Expandable Row
  aircraftDetail: {
    // Section titles
    equipment: "Vybavení",
    softwareFirmware: "Software a firmware",
    serviceHistory: "Historie servisu",
    
    // Equipment section
    batteries: "Baterie",
    accessories: "Příslušenství",
    noEquipment: "K tomuto dronu není přiřazeno žádné vybavení",
    noEquipmentHint: "Přiřaďte baterie nebo příslušenství pro sledování vybavení",
    
    // Status labels
    statusActive: "Aktivní",
    statusMaintenance: "Údržba",
    statusRetired: "Vyřazeno",
    
    // Firmware section
    firmwareVersion: "Verze firmware",
    firmwareUpToDate: "Aktuální",
    firmwareUpdateAvailable: "Aktualizace dostupná",
    noFirmwareInfo: "Žádné informace o firmware",
    
    // Service history section
    noServiceRecords: "Zatím žádné servisní záznamy",
    noServiceRecordsHint: "Přidejte záznamy o údržbě pro sledování historie servisu",
    addRecord: "Přidat záznam",
    workPerformed: "Provedené práce",
    partsUsed: "Použité díly",
    laborHours: "Pracovní hodiny",
    technician: "Technik",
    
    // ServiceLogForm
    serviceDate: "Datum servisu",
    serviceDateHint: "Ponechte prázdné pro aktuální datum",
    technicianPlaceholder: "Jméno technika",
    workPerformedPlaceholder: "Popište provedenou práci (min. 5 znaků)...",
    partNamePlaceholder: "Název dílu",
    partNumberPlaceholder: "Č. dílu",
    serviceLogAdded: "Servisní záznam přidán",
    serviceLogFailed: "Nepodařilo se přidat záznam",
    workPerformedMinLength: "Popis práce musí mít alespoň 5 znaků",
    save: "Uložit",
    cancel: "Zrušit",
    
    // Equipment types
    equipmentTypes: {
      controller: "Ovladač",
      payload: "Zátěž",
      gimbal: "Gimbal",
      rtk_module: "RTK modul",
      remote_id_module: "Remote ID modul",
      other: "Ostatní"
    },
    
    // Block E3a: Equipment Suggestion Banner
    equipmentSuggestion: {
      title: "Doporuceni vybaveni",
      remoteIdSuggestion: "V inventari je k tomuto dronu prirazen externi Remote ID modul — potvrdite, ze je na palube?",
      parachuteSuggestion: "V inventari je k tomuto dronu prirazen padak — potvrdite, ze je nainstalovan?",
      ftsSuggestion: "V inventari je k tomuto dronu prirazen system ukonceni letu — potvrdite, ze je aktivni?",
      geoAwarenessSuggestion: "V inventari je k tomuto dronu prirazeno zarizeni pro geo-awareness — potvrdite, ze je aktivni?",
      confirmEquipment: "Potvrdit vybaveni",
      permissionRequired: "Pro potvrzeni vybaveni je vyzadovana role spravce flotily",
      confirmed: "Potvrzeno",
      confirmFailed: "Nepodarilo se potvrdit vybaveni"
    }
  },
};

export default cs;
